// Generated by scripts/generate-india-pilot-masjids.mjs from public OSM records.
// Do not hand-edit records here; regenerate the pilot dataset instead.

export type IndiaPilotMasjidRecord = {
  [key: string]: unknown
  id: string
  slug: string
  nameEnglish: string
  nameUrdu: string | null
  city: string
  district: string
  state: string
  addressLine1: string
  sect: string | null
  capacity: number | null
  verified: boolean
  rating: number | null
  reviews: number | null
  plan: string
  planLabel: string
  imam: string
  president: string
  phone: string
  contactPhone: string
  contactEmail: string
  isWaqf: boolean
  isWaqfRegistered: boolean
  photo: string
  coverPhoto: string
  photos: string[]
  nextSalah: string
  latitude: number
  longitude: number
  facilities: string[]
  description: string
  importSource: string
  sourceQuality: string
  pilotSort: number
}

export const INDIA_PILOT_MASJIDS: IndiaPilotMasjidRecord[] = [
  {
    "id": "osm-node-817353672",
    "slug": "spanish-mosque-begumpet-hyderabad",
    "nameEnglish": "Spanish Mosque",
    "nameUrdu": null,
    "city": "Hyderabad",
    "district": "Begumpet",
    "state": "Telangana",
    "addressLine1": "Spanish Mosque, Sardar Patel Road, Prakash Nagar, Begumpet, Ward 149 Begumpet, Greater Hyderabad Municipal Corporation North Zone, Hyderabad, Balanagar mandal, Medchal–Malkajgiri, Telangana, 500133, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:38",
    "latitude": 17.443726,
    "longitude": 78.4725554,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Spanish Mosque is an OpenStreetMap-listed mosque/place of worship in Begumpet, Hyderabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/817353672",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 0
  },
  {
    "id": "osm-way-72531982",
    "slug": "shirazi-mosque-dongri-mumbai",
    "nameEnglish": "Shirazi Mosque",
    "nameUrdu": null,
    "city": "Mumbai",
    "district": "Dongri",
    "state": "Maharashtra",
    "addressLine1": "Shirazi Mosque, Dharmshala Road, Umerkhadi, Dongri, B Ward, Mumbai Zone 1, Mumbai City District, Maharashtra, 400003, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:59",
    "latitude": 18.9588989,
    "longitude": 72.8338494,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Shirazi Mosque is an OpenStreetMap-listed mosque/place of worship in Dongri, Mumbai. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/72531982",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 1
  },
  {
    "id": "osm-way-1326213016",
    "slug": "taiba-mosque-goregaon-west-mumbai",
    "nameEnglish": "Taiba Mosque",
    "nameUrdu": null,
    "city": "Mumbai",
    "district": "Goregaon West",
    "state": "Maharashtra",
    "addressLine1": "Taiba Mosque, Oshiwara Garden Road, Goregaon West, K/W Ward, Mumbai Zone 3, Mumbai, Mumbai Suburban District, Maharashtra, 400102, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:59",
    "latitude": 19.1452564,
    "longitude": 72.8452007,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Taiba Mosque is an OpenStreetMap-listed mosque/place of worship in Goregaon West, Mumbai. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1326213016",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 2
  },
  {
    "id": "osm-node-2567620985",
    "slug": "anushaktinagar-mosque-anushakti-nagar-mumbai",
    "nameEnglish": "Anushaktinagar Mosque",
    "nameUrdu": null,
    "city": "Mumbai",
    "district": "Anushakti Nagar",
    "state": "Maharashtra",
    "addressLine1": "Anushaktinagar Mosque, Atomic Enegry Central School 1 Road, Anushakti Nagar, M/E Ward, Mumbai Zone 5, Mumbai, Mumbai Suburban District, Maharashtra, 400094, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:59",
    "latitude": 19.038208,
    "longitude": 72.9208801,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Anushaktinagar Mosque is an OpenStreetMap-listed mosque/place of worship in Anushakti Nagar, Mumbai. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/2567620985",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 3
  },
  {
    "id": "osm-way-223903623",
    "slug": "moti-masjid-old-delhi-delhi",
    "nameEnglish": "Moti Masjid",
    "nameUrdu": null,
    "city": "Delhi",
    "district": "Old Delhi",
    "state": "Delhi",
    "addressLine1": "Moti Masjid, Mahatma Gandhi Marg, Old Delhi, Kotwali Tehsil, Central Delhi, Delhi, 110006, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 28.6568482,
    "longitude": 77.2431423,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Moti Masjid is an OpenStreetMap-listed mosque/place of worship in Old Delhi, Delhi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/223903623",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 4
  },
  {
    "id": "osm-node-5018661121",
    "slug": "alami-markaz-banglewali-masjid-defence-colony-tehsil-delhi",
    "nameEnglish": "Alami Markaz Banglewali masjid",
    "nameUrdu": null,
    "city": "Delhi",
    "district": "Defence Colony Tehsil",
    "state": "Delhi",
    "addressLine1": "Alami Markaz Banglewali masjid, Mathura Road, Defence Colony Tehsil, South East Delhi, Delhi, 110013, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 28.5917254,
    "longitude": 77.2433836,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Alami Markaz Banglewali masjid is an OpenStreetMap-listed mosque/place of worship in Defence Colony Tehsil, Delhi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/5018661121",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 5
  },
  {
    "id": "osm-node-1038357043",
    "slug": "sunehri-masjid-old-delhi-delhi",
    "nameEnglish": "Sunehri Masjid",
    "nameUrdu": "سنہری مسجد",
    "city": "Delhi",
    "district": "Old Delhi",
    "state": "Delhi",
    "addressLine1": "Sunehri Masjid, Nishadraj Marg, Meena Bazaar, Old Delhi, Kotwali Tehsil, Central Delhi, Delhi, 110006, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 28.6504594,
    "longitude": 77.2396485,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Sunehri Masjid is an OpenStreetMap-listed mosque/place of worship in Old Delhi, Delhi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/1038357043",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 6
  },
  {
    "id": "osm-way-265824671",
    "slug": "shahi-sunehri-masjid-old-delhi-delhi",
    "nameEnglish": "Shahi Sunehri Masjid",
    "nameUrdu": null,
    "city": "Delhi",
    "district": "Old Delhi",
    "state": "Delhi",
    "addressLine1": "Shahi Sunehri Masjid, Chandni Chowk, Old Delhi, Kotwali Tehsil, Central Delhi, Delhi, 110006, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "established": 1721,
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 28.6560888,
    "longitude": 77.2319044,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Shahi Sunehri Masjid is an OpenStreetMap-listed mosque/place of worship in Old Delhi, Delhi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/265824671",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 7
  },
  {
    "id": "osm-way-231621851",
    "slug": "moth-ki-masjid-hauz-khas-tehsil-delhi",
    "nameEnglish": "Moth Ki Masjid",
    "nameUrdu": null,
    "city": "Delhi",
    "district": "Hauz Khas Tehsil",
    "state": "Delhi",
    "addressLine1": "Moth Ki Masjid, Wing Commander Mahinder Kumar Jain Marg, Anand Lok, Hauz Khas Tehsil, South Delhi, Delhi, 110049, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "established": 1505,
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 28.5626385,
    "longitude": 77.2179673,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Moth Ki Masjid is an OpenStreetMap-listed mosque/place of worship in Hauz Khas Tehsil, Delhi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/231621851",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 8
  },
  {
    "id": "osm-way-351391574",
    "slug": "moti-masjid-mehrauli-delhi",
    "nameEnglish": "Moti Masjid",
    "nameUrdu": "موتی مسجد",
    "city": "Delhi",
    "district": "Mehrauli",
    "state": "Delhi",
    "addressLine1": "Moti Masjid, Ward Number 7, Zafar Mahal Road, Mehrauli, Mehrauli Tehsil, South Delhi, Delhi, 110030, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 28.519159,
    "longitude": 77.1801273,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Moti Masjid is an OpenStreetMap-listed mosque/place of worship in Mehrauli, Delhi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/351391574",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 9
  },
  {
    "id": "osm-way-1304106649",
    "slug": "haji-sir-ismail-sait-masjid-kadugodi-bengaluru",
    "nameEnglish": "Haji Sir Ismail Sait Masjid",
    "nameUrdu": null,
    "city": "Bengaluru",
    "district": "Kadugodi",
    "state": "Karnataka",
    "addressLine1": "Haji Sir Ismail Sait Masjid, Chariot Street, Kadugodi, Bengaluru East City Corporation, Bengaluru, Bangalore East, Bengaluru Urban, Karnataka, 560067, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 12.9963548,
    "longitude": 77.7641492,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Haji Sir Ismail Sait Masjid is an OpenStreetMap-listed mosque/place of worship in Kadugodi, Bengaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1304106649",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 10
  },
  {
    "id": "osm-way-532166920",
    "slug": "masjid-i-askari-ashokanagar-bengaluru",
    "nameEnglish": "Masjid i Askari",
    "nameUrdu": null,
    "city": "Bengaluru",
    "district": "Ashokanagar",
    "state": "Karnataka",
    "addressLine1": "Masjid i Askari, Hosur Road, Ashokanagar, Bengaluru Central City Corporation, Bengaluru, Bangalore North, Bengaluru Urban, Karnataka, 560025, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 12.9636588,
    "longitude": 77.6064734,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid i Askari is an OpenStreetMap-listed mosque/place of worship in Ashokanagar, Bengaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/532166920",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 11
  },
  {
    "id": "osm-way-1095458699",
    "slug": "masjid-e-bilal-richmond-town-bengaluru",
    "nameEnglish": "Masjid-e-Bilal",
    "nameUrdu": null,
    "city": "Bengaluru",
    "district": "Richmond Town",
    "state": "Karnataka",
    "addressLine1": "Masjid-e-Bilal, Berlie Street, Pudupadacheri, Richmond Town, Shanthinagar, Bengaluru Central City Corporation, Bengaluru, Bangalore North, Bengaluru Urban, Karnataka, 560027, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 12.959233,
    "longitude": 77.6015485,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid-e-Bilal is an OpenStreetMap-listed mosque/place of worship in Richmond Town, Bengaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1095458699",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 12
  },
  {
    "id": "osm-way-1364170754",
    "slug": "masjid-e-jafar-kacharakanahalli-bengaluru",
    "nameEnglish": "Masjid-E-Jafar",
    "nameUrdu": null,
    "city": "Bengaluru",
    "district": "Kacharakanahalli",
    "state": "Karnataka",
    "addressLine1": "Masjid-E-Jafar, 4th G Main Road, HRBR Layout 2nd Block, Kacharakanahalli, Bengaluru North City Corporation, Bengaluru, Bangalore North, Bengaluru Urban, Karnataka, 560043, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 13.0223587,
    "longitude": 77.6390418,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid-E-Jafar is an OpenStreetMap-listed mosque/place of worship in Kacharakanahalli, Bengaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1364170754",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 13
  },
  {
    "id": "osm-way-354541898",
    "slug": "jamia-masjid-shafi-i-zone-10-kodambakkam-chennai",
    "nameEnglish": "Jamia Masjid (Shafi'i)",
    "nameUrdu": null,
    "city": "Chennai",
    "district": "Zone 10 Kodambakkam",
    "state": "Tamil Nadu",
    "addressLine1": "Jamia Masjid (Shafi'i), South Usman Road, CMWSSB Division 136, Ward 136, Zone 10 Kodambakkam, Chennai, Tamil Nadu, 600017, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:34",
    "latitude": 13.0391357,
    "longitude": 80.2312573,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamia Masjid (Shafi'i) is an OpenStreetMap-listed mosque/place of worship in Zone 10 Kodambakkam, Chennai. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/354541898",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 14
  },
  {
    "id": "osm-node-4209581189",
    "slug": "tipu-sultan-mosque-chandni-chowk-kolkata",
    "nameEnglish": "Tipu Sultan Mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Chandni Chowk",
    "state": "West Bengal",
    "addressLine1": "Tipu Sultan Mosque, Lenin Sarani, Chandni Chowk, Kolkata, Kolkata Metropolitan Area, Kolkata, West Bengal, 700013, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.5655026,
    "longitude": 88.3520876,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Tipu Sultan Mosque is an OpenStreetMap-listed mosque/place of worship in Chandni Chowk, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/4209581189",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 15
  },
  {
    "id": "osm-way-325837615",
    "slug": "nakhoda-mosque-tiretta-kolkata",
    "nameEnglish": "Nakhoda Mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Tiretta",
    "state": "West Bengal",
    "addressLine1": "Nakhoda Mosque, Rabindra Sarani, Tiretta Bazaar, Tiretta, Kolkata, Kolkata Metropolitan Area, Kolkata, West Bengal, 700073, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.5776211,
    "longitude": 88.3561126,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Nakhoda Mosque is an OpenStreetMap-listed mosque/place of worship in Tiretta, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/325837615",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 16
  },
  {
    "id": "osm-way-121761952",
    "slug": "tipu-sultan-mosque-tollygunge-kolkata",
    "nameEnglish": "Tipu Sultan Mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Tollygunge",
    "state": "West Bengal",
    "addressLine1": "Tipu Sultan Mosque, Deshapran Sashmal Road, Tollygunge, Kolkata, Kolkata Metropolitan Area, Kolkata, West Bengal, 700033, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.5017808,
    "longitude": 88.3454442,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Tipu Sultan Mosque is an OpenStreetMap-listed mosque/place of worship in Tollygunge, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/121761952",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 17
  },
  {
    "id": "osm-node-10863198505",
    "slug": "al-imraan-mosque-paikpara-kolkata",
    "nameEnglish": "Al-Imraan Mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Paikpara",
    "state": "West Bengal",
    "addressLine1": "Al-Imraan Mosque, Radha Gobinda Kar Road, Paikpara, Kolkata, Kolkata Metropolitan Area, Kolkata, West Bengal, 700037, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.6051884,
    "longitude": 88.3842198,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Al-Imraan Mosque is an OpenStreetMap-listed mosque/place of worship in Paikpara, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/10863198505",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 18
  },
  {
    "id": "osm-node-7028996085",
    "slug": "ismail-mosque-watganj-kolkata",
    "nameEnglish": "Ismail Mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Watganj",
    "state": "West Bengal",
    "addressLine1": "Ismail Mosque, Karl Marx Sarani, Watganj, Kolkata, Kolkata Metropolitan Area, Kolkata, West Bengal, 700023, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.5386813,
    "longitude": 88.3213366,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Ismail Mosque is an OpenStreetMap-listed mosque/place of worship in Watganj, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7028996085",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 19
  },
  {
    "id": "osm-way-755609520",
    "slug": "sudarsan-mosque-pandua-polba-road-kolkata",
    "nameEnglish": "Sudarsan Mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Pandua - Polba Road",
    "state": "West Bengal",
    "addressLine1": "Sudarsan Mosque, Pandua - Polba Road, Polba, Kolkata Metropolitan Area, Polba - Dadpur, Hooghly, West Bengal, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.9762915,
    "longitude": 88.2791422,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Sudarsan Mosque is an OpenStreetMap-listed mosque/place of worship in Pandua - Polba Road, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/755609520",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 20
  },
  {
    "id": "osm-node-10914688766",
    "slug": "pir-baba-mosque-palta-kolkata",
    "nameEnglish": "pir baba mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Palta",
    "state": "West Bengal",
    "addressLine1": "pir baba mosque, SN Banerjee Road / Barrack Road, Muchi Mahal, Palta, Serampore, Kolkata Metropolitan Area, Barrackpore, North 24 Parganas, West Bengal, 743101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.7671507,
    "longitude": 88.3516056,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "pir baba mosque is an OpenStreetMap-listed mosque/place of worship in Palta, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/10914688766",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 21
  },
  {
    "id": "osm-node-7149569347",
    "slug": "amanati-mosque-maulana-abul-kalam-azad-road-kolkata",
    "nameEnglish": "Amanati Mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Maulana Abul Kalam Azad Road",
    "state": "West Bengal",
    "addressLine1": "Amanati Mosque, Maulana Abul Kalam Azad Road, Madhyamgram, Kolkata Metropolitan Area, Barasat - I, North 24 Parganas, West Bengal, 700127, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.7184103,
    "longitude": 88.4696636,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Amanati Mosque is an OpenStreetMap-listed mosque/place of worship in Maulana Abul Kalam Azad Road, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7149569347",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 22
  },
  {
    "id": "osm-node-2477399604",
    "slug": "baruipur-mosque-kulpi-road-kolkata",
    "nameEnglish": "Baruipur Mosque",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Kulpi Road",
    "state": "West Bengal",
    "addressLine1": "Baruipur Mosque, Kulpi Road, Baruipur, Kolkata Metropolitan Area, Baruipur, South 24 Parganas, West Bengal, 700144, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.3647533,
    "longitude": 88.4323474,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Baruipur Mosque is an OpenStreetMap-listed mosque/place of worship in Kulpi Road, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/2477399604",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 23
  },
  {
    "id": "osm-node-12925431744",
    "slug": "ostajee-para-jama-masjid-thakurpukur-kolkata",
    "nameEnglish": "Ostajee Para Jama Masjid",
    "nameUrdu": null,
    "city": "Kolkata",
    "district": "Thakurpukur",
    "state": "West Bengal",
    "addressLine1": "Ostajee Para Jama Masjid, 56, Amritalal Mukherjee Rd, Thakurpukur, Kolkata, Kolkata Metropolitan Area, Kolkata, West Bengal, 700063, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:53",
    "latitude": 22.4717351,
    "longitude": 88.3013754,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Ostajee Para Jama Masjid is an OpenStreetMap-listed mosque/place of worship in Thakurpukur, Kolkata. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12925431744",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 24
  },
  {
    "id": "osm-node-5149356338",
    "slug": "shia-mosque-sarai-peth-pune",
    "nameEnglish": "Shia Mosque",
    "nameUrdu": null,
    "city": "Pune",
    "district": "Sarai Peth",
    "state": "Maharashtra",
    "addressLine1": "Shia Mosque, Sarai Peth, Junnar, Pune District, Maharashtra, 410502, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 19.2070091,
    "longitude": 73.8749555,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Shia Mosque is an OpenStreetMap-listed mosque/place of worship in Sarai Peth, Pune. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/5149356338",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 25
  },
  {
    "id": "osm-way-605637928",
    "slug": "baba-lului-s-mosque-bhavna-colony-ahmedabad",
    "nameEnglish": "Baba Lului's Mosque",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "Bhavna colony",
    "state": "Gujarat",
    "addressLine1": "Baba Lului's Mosque, Sabarmati River front Road, Bhavna colony, Maninagar Taluka, Ahmedabad, Gujarat, 380022, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 23.0088458,
    "longitude": 72.5757776,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Baba Lului's Mosque is an OpenStreetMap-listed mosque/place of worship in Bhavna colony, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/605637928",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 26
  },
  {
    "id": "osm-way-758933549",
    "slug": "bibi-achut-kuki-masjid-madhupura-ahmedabad",
    "nameEnglish": "Bibi Achut Kuki masjid",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "Madhupura",
    "state": "Gujarat",
    "addressLine1": "Bibi Achut Kuki masjid, BRTS Route, Madhupura, Asarva Taluka, Ahmedabad, Gujarat, 380004, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 23.0476678,
    "longitude": 72.5811898,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Bibi Achut Kuki masjid is an OpenStreetMap-listed mosque/place of worship in Madhupura, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/758933549",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 27
  },
  {
    "id": "osm-way-759148036",
    "slug": "fateh-masjid-dariyapur-ahmedabad",
    "nameEnglish": "Fateh masjid",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "Dariyapur",
    "state": "Gujarat",
    "addressLine1": "Fateh masjid, Kasturba Gandhi Road, Dariyapur, Ahmedabad, Gujarat, 380001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 23.0368714,
    "longitude": 72.590829,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Fateh masjid is an OpenStreetMap-listed mosque/place of worship in Dariyapur, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/759148036",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 28
  },
  {
    "id": "osm-node-7163489711",
    "slug": "masjid-e-bahare-shariat-danilimda-ahmedabad",
    "nameEnglish": "Masjid e Bahare Shariat",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "DaniLimda",
    "state": "Gujarat",
    "addressLine1": "Masjid e Bahare Shariat, 120 Feet Circular Road, DaniLimda, Maninagar Taluka, Ahmedabad, Gujarat, 380043, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 22.992313,
    "longitude": 72.5765629,
    "facilities": [
      "Prayer Hall",
      "Wheelchair access"
    ],
    "description": "Masjid e Bahare Shariat is an OpenStreetMap-listed mosque/place of worship in DaniLimda, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7163489711",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 29
  },
  {
    "id": "osm-node-7157714216",
    "slug": "masjid-e-khatimul-ambiya-narol-sarkhej-road-ahmedabad",
    "nameEnglish": "Masjid e Khatimul Ambiya",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "Narol Sarkhej Road",
    "state": "Gujarat",
    "addressLine1": "Masjid e Khatimul Ambiya, Narol Sarkhej Road, Piplaj, Maninagar Taluka, Ahmedabad, Gujarat, 382405, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 22.9795627,
    "longitude": 72.5759353,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid e Khatimul Ambiya is an OpenStreetMap-listed mosque/place of worship in Narol Sarkhej Road, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7157714216",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 30
  },
  {
    "id": "osm-node-13141074680",
    "slug": "navi-masjid-masjid-e-nawab-danilimda-ahmedabad",
    "nameEnglish": "Navi Masjid (Masjid-e-Nawab)",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "DaniLimda",
    "state": "Gujarat",
    "addressLine1": "Navi Masjid (Masjid-e-Nawab), Shafi Manzil Road, DaniLimda, Maninagar Taluka, Ahmedabad, Gujarat, 380028, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 22.9957645,
    "longitude": 72.586788,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Navi Masjid (Masjid-e-Nawab) is an OpenStreetMap-listed mosque/place of worship in DaniLimda, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13141074680",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 31
  },
  {
    "id": "osm-node-7157714217",
    "slug": "shahi-masjid-danilimda-ahmedabad",
    "nameEnglish": "Shahi Masjid",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "DaniLimda",
    "state": "Gujarat",
    "addressLine1": "Shahi Masjid, Lalbhai Kundiwala Marg, DaniLimda, Maninagar Taluka, Ahmedabad, Gujarat, 380043, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 22.9976863,
    "longitude": 72.5886917,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Shahi Masjid is an OpenStreetMap-listed mosque/place of worship in DaniLimda, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7157714217",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 32
  },
  {
    "id": "osm-node-7157714218",
    "slug": "shahi-masjid-shah-e-alam-dargah-shah-e-alam-roza-ahmedabad",
    "nameEnglish": "Shahi Masjid - Shah e Alam Dargah",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "Shah E Alam Roza",
    "state": "Gujarat",
    "addressLine1": "Shahi Masjid - Shah e Alam Dargah, Shah Alam Road, Shah E Alam Roza, Maninagar Taluka, Ahmedabad, Gujarat, 380043, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 22.9944381,
    "longitude": 72.5889358,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Shahi Masjid - Shah e Alam Dargah is an OpenStreetMap-listed mosque/place of worship in Shah E Alam Roza, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7157714218",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 33
  },
  {
    "id": "osm-node-7157714220",
    "slug": "shahi-masjid-dargah-hazrat-ali-sher-bangali-paldi-ahmedabad",
    "nameEnglish": "Shahi Masjid - Dargah Hazrat Ali Sher Bangali",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "Paldi",
    "state": "Gujarat",
    "addressLine1": "Shahi Masjid - Dargah Hazrat Ali Sher Bangali, Chimanlal Girdharlal Road, Paldi, SabarmatiTaluka, Ahmedabad, Gujarat, 380007, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 23.0104389,
    "longitude": 72.5651855,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Shahi Masjid - Dargah Hazrat Ali Sher Bangali is an OpenStreetMap-listed mosque/place of worship in Paldi, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7157714220",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 34
  },
  {
    "id": "osm-node-7159077260",
    "slug": "jambudi-masjid-behrampura-ahmedabad",
    "nameEnglish": "Jambudi Masjid",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "Behrampura",
    "state": "Gujarat",
    "addressLine1": "Jambudi Masjid, Ashok Bhatt Flyover, Behrampura, Maninagar Taluka, Ahmedabad, Gujarat, 380022, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 23.012687,
    "longitude": 72.584438,
    "facilities": [
      "Prayer Hall",
      "Wheelchair access"
    ],
    "description": "Jambudi Masjid is an OpenStreetMap-listed mosque/place of worship in Behrampura, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7159077260",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 35
  },
  {
    "id": "osm-node-13680967438",
    "slug": "ajeetgarh-mosque-shahpura-jaipur-link-road-jaipur",
    "nameEnglish": "Ajeetgarh Mosque",
    "nameUrdu": null,
    "city": "Jaipur",
    "district": "Shahpura-Jaipur Link Road",
    "state": "Rajasthan",
    "addressLine1": "Ajeetgarh Mosque, Shahpura-Jaipur Link Road, Ajeetgarh, Sri Madhopur Tehsil, Sikar, Rajasthan, 332701, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:53",
    "latitude": 27.4178153,
    "longitude": 75.8177997,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Ajeetgarh Mosque is an OpenStreetMap-listed mosque/place of worship in Shahpura-Jaipur Link Road, Jaipur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13680967438",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 36
  },
  {
    "id": "osm-way-1489339452",
    "slug": "firdaus-masjid-bani-park-jaipur",
    "nameEnglish": "Firdaus Masjid",
    "nameUrdu": null,
    "city": "Jaipur",
    "district": "Bani Park",
    "state": "Rajasthan",
    "addressLine1": "Firdaus Masjid, Firdaus Masjid Road, Bani Park, Jaipur, Jaipur Municipal Corporation, Jaipur Tehsil, Jaipur, Rajasthan, 302016, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:53",
    "latitude": 26.9480958,
    "longitude": 75.8049422,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Firdaus Masjid is an OpenStreetMap-listed mosque/place of worship in Bani Park, Jaipur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1489339452",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 37
  },
  {
    "id": "osm-way-1391748699",
    "slug": "bilal-masjid-bani-park-jaipur",
    "nameEnglish": "Bilal Masjid",
    "nameUrdu": null,
    "city": "Jaipur",
    "district": "Bani Park",
    "state": "Rajasthan",
    "addressLine1": "Bilal Masjid, 90 Feet Road, Bani Park, Jaipur, Jaipur Municipal Corporation, Jaipur Tehsil, Jaipur, Rajasthan, 302006, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:53",
    "latitude": 26.9461271,
    "longitude": 75.8067104,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Bilal Masjid is an OpenStreetMap-listed mosque/place of worship in Bani Park, Jaipur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1391748699",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 38
  },
  {
    "id": "osm-way-962291076",
    "slug": "nurani-masjid-jagatpura-jaipur",
    "nameEnglish": "nurani masjid",
    "nameUrdu": null,
    "city": "Jaipur",
    "district": "Jagatpura",
    "state": "Rajasthan",
    "addressLine1": "nurani masjid, Underpass, Jagatpura, Jaipur Municipal Corporation, Sanganer Tehsil, Jaipur, Rajasthan, 302014, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:53",
    "latitude": 26.8431987,
    "longitude": 75.8177108,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "nurani masjid is an OpenStreetMap-listed mosque/place of worship in Jagatpura, Jaipur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/962291076",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 39
  },
  {
    "id": "osm-way-1204917996",
    "slug": "nalbandan-masjid-ramganj-jaipur",
    "nameEnglish": "Nalbandan Masjid",
    "nameUrdu": null,
    "city": "Jaipur",
    "district": "Ramganj",
    "state": "Rajasthan",
    "addressLine1": "Nalbandan Masjid, Amer Road, Ramganj, Jaipur, Jaipur Municipal Corporation, Jaipur Tehsil, Jaipur, Rajasthan, 302002, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:53",
    "latitude": 26.9318671,
    "longitude": 75.8360191,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Nalbandan Masjid is an OpenStreetMap-listed mosque/place of worship in Ramganj, Jaipur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1204917996",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 40
  },
  {
    "id": "osm-node-12669189230",
    "slug": "masjid-e-ilahi-jothwara-jaipur",
    "nameEnglish": "Masjid e Ilahi",
    "nameUrdu": null,
    "city": "Jaipur",
    "district": "Jothwara",
    "state": "Rajasthan",
    "addressLine1": "Masjid e Ilahi, Joshi Marg, Maa Hinglaaj Nagar, Jothwara, Jaipur, Jaipur Municipal Corporation, Jaipur Tehsil, Jaipur, Rajasthan, 302001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:53",
    "latitude": 26.9501257,
    "longitude": 75.7490895,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid e Ilahi is an OpenStreetMap-listed mosque/place of worship in Jothwara, Jaipur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12669189230",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 41
  },
  {
    "id": "osm-node-12669189233",
    "slug": "madina-masjid-jothwara-jaipur",
    "nameEnglish": "Madina Masjid",
    "nameUrdu": null,
    "city": "Jaipur",
    "district": "Jothwara",
    "state": "Rajasthan",
    "addressLine1": "Madina Masjid, Joshi Marg, Maa Hinglaaj Nagar, Jothwara, Jaipur, Jaipur Municipal Corporation, Jaipur Tehsil, Jaipur, Rajasthan, 302001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:53",
    "latitude": 26.947552,
    "longitude": 75.7496994,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Madina Masjid is an OpenStreetMap-listed mosque/place of worship in Jothwara, Jaipur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12669189233",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 42
  },
  {
    "id": "osm-way-1172579689",
    "slug": "jama-masjid-kherjroli-sh-37c-jaipur",
    "nameEnglish": "Jama Masjid Kherjroli",
    "nameUrdu": null,
    "city": "Jaipur",
    "district": "SH 37C",
    "state": "Rajasthan",
    "addressLine1": "Jama Masjid Kherjroli, SH 37C, Khejroli, Chomu Tehsil, Jaipur, Rajasthan, 303803, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:53",
    "latitude": 27.3327447,
    "longitude": 75.6974398,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jama Masjid Kherjroli is an OpenStreetMap-listed mosque/place of worship in SH 37C, Jaipur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1172579689",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 43
  },
  {
    "id": "osm-way-364479901",
    "slug": "moti-masjid-ibrahimpura-bhopal",
    "nameEnglish": "Moti Masjid",
    "nameUrdu": null,
    "city": "Bhopal",
    "district": "Ibrahimpura",
    "state": "Madhya Pradesh",
    "addressLine1": "Moti Masjid, Neem road, Ibrahimpura, Bhopal, Huzur Tahsil, Bhopal, Madhya Pradesh, 462001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:37",
    "latitude": 23.2556174,
    "longitude": 77.3994281,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Moti Masjid is an OpenStreetMap-listed mosque/place of worship in Ibrahimpura, Bhopal. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/364479901",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 44
  },
  {
    "id": "osm-way-414069157",
    "slug": "sufia-masjid-bhopal-bhopal",
    "nameEnglish": "Sufia Masjid",
    "nameUrdu": null,
    "city": "Bhopal",
    "district": "Bhopal",
    "state": "Madhya Pradesh",
    "addressLine1": "Sufia Masjid, Kohefiza, VIP road, Khanugaon, Bhopal, Huzur Tahsil, Bhopal, Madhya Pradesh, 462001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:37",
    "latitude": 23.2634286,
    "longitude": 77.372502,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Sufia Masjid is an OpenStreetMap-listed mosque/place of worship in Bhopal, Bhopal. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/414069157",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 45
  },
  {
    "id": "osm-node-4836553353",
    "slug": "masjid-ashbagh-ibrahimpura-bhopal",
    "nameEnglish": "Masjid Ashbagh",
    "nameUrdu": null,
    "city": "Bhopal",
    "district": "Ibrahimpura",
    "state": "Madhya Pradesh",
    "addressLine1": "Masjid Ashbagh, MD3108, Jr LIG Colony, Ibrahimpura, Bhopal, Huzur Tahsil, Bhopal, Madhya Pradesh, 462001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:37",
    "latitude": 23.2563331,
    "longitude": 77.4190789,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid Ashbagh is an OpenStreetMap-listed mosque/place of worship in Ibrahimpura, Bhopal. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/4836553353",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 46
  },
  {
    "id": "osm-way-473803819",
    "slug": "bohra-mosque-vaishali-nagar-indore",
    "nameEnglish": "Bohra Mosque",
    "nameUrdu": null,
    "city": "Indore",
    "district": "Vaishali Nagar",
    "state": "Madhya Pradesh",
    "addressLine1": "Bohra Mosque, Agra-Bombay Road, Vaishali Nagar, Indore City, Indore, Juni Indore Tahsil, Indore, Madhya Pradesh, 452014, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:43",
    "latitude": 22.6964203,
    "longitude": 75.8566783,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Bohra Mosque is an OpenStreetMap-listed mosque/place of worship in Vaishali Nagar, Indore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/473803819",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 47
  },
  {
    "id": "osm-node-5376039832",
    "slug": "gulzar-colony-masjid-mosque-indore-city-indore",
    "nameEnglish": "Gulzar colony masjid (mosque)",
    "nameUrdu": null,
    "city": "Indore",
    "district": "Indore City",
    "state": "Madhya Pradesh",
    "addressLine1": "Gulzar colony masjid (mosque), Manik Bagh Flyover, Indore City, Indore, Juni Indore Tahsil, Indore, Madhya Pradesh, 452001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:43",
    "latitude": 22.6969466,
    "longitude": 75.8545928,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Gulzar colony masjid (mosque) is an OpenStreetMap-listed mosque/place of worship in Indore City, Indore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/5376039832",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 48
  },
  {
    "id": "osm-node-5458547036",
    "slug": "sri-nagar-colony-masjid-indore-city-indore",
    "nameEnglish": "Sri Nagar Colony Masjid",
    "nameUrdu": null,
    "city": "Indore",
    "district": "Indore City",
    "state": "Madhya Pradesh",
    "addressLine1": "Sri Nagar Colony Masjid, Shrinagar Main, Indore City, Indore, Juni Indore Tahsil, Indore, Madhya Pradesh, 452001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:43",
    "latitude": 22.7300626,
    "longitude": 75.8943958,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Sri Nagar Colony Masjid is an OpenStreetMap-listed mosque/place of worship in Indore City, Indore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/5458547036",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 49
  },
  {
    "id": "osm-node-12736711106",
    "slug": "ayesha-masjid-indore-city-indore",
    "nameEnglish": "Ayesha Masjid",
    "nameUrdu": null,
    "city": "Indore",
    "district": "Indore City",
    "state": "Madhya Pradesh",
    "addressLine1": "Ayesha Masjid, Bhicholi Hapsi Road, Indore City, Indore, Juni Indore Tahsil, Indore, Madhya Pradesh, 452001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:43",
    "latitude": 22.7308476,
    "longitude": 75.9132777,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Ayesha Masjid is an OpenStreetMap-listed mosque/place of worship in Indore City, Indore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12736711106",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 50
  },
  {
    "id": "osm-way-1360688326",
    "slug": "kurji-mosque-digha-patna",
    "nameEnglish": "Kurji Mosque",
    "nameUrdu": null,
    "city": "Patna",
    "district": "Digha",
    "state": "Bihar",
    "addressLine1": "Kurji Mosque, Ashok Raj Path, Digha, Patna, Patna Rural, Patna, Bihar, 800010, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:12",
    "latitude": 25.6431153,
    "longitude": 85.1034917,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kurji Mosque is an OpenStreetMap-listed mosque/place of worship in Digha, Patna. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1360688326",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 51
  },
  {
    "id": "osm-node-7478460558",
    "slug": "chauhatta-mosque-rajendra-nagar-patna",
    "nameEnglish": "Chauhatta Mosque",
    "nameUrdu": null,
    "city": "Patna",
    "district": "Rajendra Nagar",
    "state": "Bihar",
    "addressLine1": "Chauhatta Mosque, Ashok Raj Path, Rajendra Nagar, Patna, Patna Rural, Patna, Bihar, 800003, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:12",
    "latitude": 25.6186945,
    "longitude": 85.1640404,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Chauhatta Mosque is an OpenStreetMap-listed mosque/place of worship in Rajendra Nagar, Patna. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7478460558",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 52
  },
  {
    "id": "osm-way-1173114239",
    "slug": "ali-nagar-jama-masjid-ali-nager-patna",
    "nameEnglish": "Ali Nagar Jama Masjid",
    "nameUrdu": null,
    "city": "Patna",
    "district": "Ali Nager",
    "state": "Bihar",
    "addressLine1": "Ali Nagar Jama Masjid, A/12, Ali Nagar Colony, Police Colony, Anisabad, Patna, Bihar, Ali Nager, Patna, Patna Rural, Patna, Bihar, 800002, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:12",
    "latitude": 25.5866633,
    "longitude": 85.0941212,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Ali Nagar Jama Masjid is an OpenStreetMap-listed mosque/place of worship in Ali Nager, Patna. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1173114239",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 53
  },
  {
    "id": "osm-node-4561586890",
    "slug": "murtazwi-masjid-hakimganj-patna",
    "nameEnglish": "Murtazwi Masjid",
    "nameUrdu": null,
    "city": "Patna",
    "district": "Hakimganj",
    "state": "Bihar",
    "addressLine1": "Murtazwi Masjid, Madarsa Sulemania Lane, Hakimganj, Patna, Patna Rural, Patna, Bihar, 800008, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:12",
    "latitude": 25.599731,
    "longitude": 85.211307,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Murtazwi Masjid is an OpenStreetMap-listed mosque/place of worship in Hakimganj, Patna. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/4561586890",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 54
  },
  {
    "id": "osm-node-13226672501",
    "slug": "rahmatganj-masjid-nh22-patna",
    "nameEnglish": "Rahmatganj Masjid",
    "nameUrdu": null,
    "city": "Patna",
    "district": "NH22",
    "state": "Bihar",
    "addressLine1": "Rahmatganj Masjid, NH22, Masaurhi, Patna, Bihar, 804452, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:12",
    "latitude": 25.3544771,
    "longitude": 85.0365233,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Rahmatganj Masjid is an OpenStreetMap-listed mosque/place of worship in NH22, Patna. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13226672501",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 55
  },
  {
    "id": "osm-way-722702817",
    "slug": "chembittapally-juma-mosque-chullickal-kochi",
    "nameEnglish": "Chembittapally Juma Mosque",
    "nameUrdu": null,
    "city": "Kochi",
    "district": "Chullickal",
    "state": "Kerala",
    "addressLine1": "Chembittapally Juma Mosque, Darusalam Road, Kaplandi Mukku, Chullickal, Kochi, Ernakulam, Kerala, 682002, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:51",
    "latitude": 9.9488721,
    "longitude": 76.2595913,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Chembittapally Juma Mosque is an OpenStreetMap-listed mosque/place of worship in Chullickal, Kochi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/722702817",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 56
  },
  {
    "id": "osm-node-7461797458",
    "slug": "central-mahal-juma-masjid-velloorkunnam-kochi",
    "nameEnglish": "Central Mahal Juma Masjid",
    "nameUrdu": null,
    "city": "Kochi",
    "district": "Velloorkunnam",
    "state": "Kerala",
    "addressLine1": "Central Mahal Juma Masjid, Kochi - Madurai - Dhanushkodi Road, Velloorkunnam, Muvattupuzha, Ernakulam, Kerala, 686661, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:51",
    "latitude": 9.9899598,
    "longitude": 76.5834426,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Central Mahal Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Velloorkunnam, Kochi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7461797458",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 57
  },
  {
    "id": "osm-way-408208967",
    "slug": "thekan-maliapuram-jama-masjid-puthuvype-kochi",
    "nameEnglish": "Thekan Maliapuram Jama Masjid",
    "nameUrdu": null,
    "city": "Kochi",
    "district": "Puthuvype",
    "state": "Kerala",
    "addressLine1": "Thekan Maliapuram Jama Masjid, Vypin - Pallippuram Road, Puthuvype, Kochi, Ernakulam, Kerala, 682508, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:51",
    "latitude": 9.9939874,
    "longitude": 76.236102,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Thekan Maliapuram Jama Masjid is an OpenStreetMap-listed mosque/place of worship in Puthuvype, Kochi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/408208967",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 58
  },
  {
    "id": "osm-node-8444251100",
    "slug": "ahmadiyya-muslim-jama-ath-masjid-fort-kochi-kochi",
    "nameEnglish": "Ahmadiyya Muslim Jama-Ath Masjid",
    "nameUrdu": null,
    "city": "Kochi",
    "district": "Fort Kochi",
    "state": "Kerala",
    "addressLine1": "Ahmadiyya Muslim Jama-Ath Masjid, Pullupalam Road, Kunnumpuram, Fort Vypin, Fort Kochi, Kochi, Ernakulam, Kerala, 682001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:51",
    "latitude": 9.9637815,
    "longitude": 76.2487026,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Ahmadiyya Muslim Jama-Ath Masjid is an OpenStreetMap-listed mosque/place of worship in Fort Kochi, Kochi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8444251100",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 59
  },
  {
    "id": "osm-node-12005976569",
    "slug": "mosque-juma-masjid-east-kizhakkoth-kozhikode",
    "nameEnglish": "Mosque (Juma Masjid)",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "East Kizhakkoth",
    "state": "Kerala",
    "addressLine1": "Mosque (Juma Masjid), NH766, East Kizhakkoth, Koduvally, Thamarassery, Kozhikode, Kerala, 673572, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.3455897,
    "longitude": 75.9002154,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Mosque (Juma Masjid) is an OpenStreetMap-listed mosque/place of worship in East Kizhakkoth, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12005976569",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 60
  },
  {
    "id": "osm-way-885058858",
    "slug": "jamiul-futuh-grand-masjid-millumpadi-colony-kozhikode",
    "nameEnglish": "Jamiul Futuh Grand Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Millumpadi Colony",
    "state": "Kerala",
    "addressLine1": "Jamiul Futuh Grand Masjid, Kodencherry - Adivaram Road, Millumpadi Colony, Adivaram, Thamarassery, Kozhikode, Kerala, 673586, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.4722946,
    "longitude": 76.0075139,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiul Futuh Grand Masjid is an OpenStreetMap-listed mosque/place of worship in Millumpadi Colony, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/885058858",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 61
  },
  {
    "id": "osm-way-896556386",
    "slug": "kayalam-muhammadiyya-juma-masjid-perumanna-road-kozhikode",
    "nameEnglish": "Kayalam Muhammadiyya Juma-Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Perumanna Road",
    "state": "Kerala",
    "addressLine1": "Pallithazham Juma-Masjid, Perumanna Road, Peruvayal, Kozhikode, Kerala, 673661, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.2483234,
    "longitude": 75.9082559,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kayalam Muhammadiyya Juma-Masjid is an OpenStreetMap-listed mosque/place of worship in Perumanna Road, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/896556386",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 62
  },
  {
    "id": "osm-node-3807814742",
    "slug": "mukkali-juma-masjid-kunjippalli-kozhikode",
    "nameEnglish": "Mukkali Juma Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Kunjippalli",
    "state": "Kerala",
    "addressLine1": "Mukkali Juma Masjid, NH66, Kunjippalli, Azhiyur, Vadakara, Kozhikode, Kerala, 673308, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.6676613,
    "longitude": 75.5594104,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Mukkali Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Kunjippalli, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/3807814742",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 63
  },
  {
    "id": "osm-node-3806141057",
    "slug": "kunjippalli-juma-masjid-kunjippalli-kozhikode",
    "nameEnglish": "Kunjippalli Juma Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Kunjippalli",
    "state": "Kerala",
    "addressLine1": "Kunjippalli Juma Masjid, NH66, Kunjippalli, Azhiyur, Vadakara, Kozhikode, Kerala, 673308, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.6775888,
    "longitude": 75.5510669,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kunjippalli Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Kunjippalli, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/3806141057",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 64
  },
  {
    "id": "osm-node-3807808552",
    "slug": "anjampeedika-juma-masjid-vyadyarkuni-colony-kozhikode",
    "nameEnglish": "Anjampeedika Juma Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Vyadyarkuni colony",
    "state": "Kerala",
    "addressLine1": "Anjampeedika Juma Masjid, Old NH66, Vyadyarkuni colony, Azhiyur, Vadakara, Kozhikode, Kerala, 673309, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.685764,
    "longitude": 75.5443482,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Anjampeedika Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Vyadyarkuni colony, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/3807808552",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 65
  },
  {
    "id": "osm-way-895580233",
    "slug": "kuruvangad-juma-masjid-quilandy-thamarassery-edavanna-road-kozhikode",
    "nameEnglish": "Kuruvangad Juma Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Quilandy - Thamarassery - Edavanna Road",
    "state": "Kerala",
    "addressLine1": "Kuruvangad Juma Masjid, Quilandy - Thamarassery - Edavanna Road, Nadathalakkal colony, Koyilandy, Koyilandi, Kozhikode, Kerala, 673300, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.4440967,
    "longitude": 75.7209659,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kuruvangad Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Quilandy - Thamarassery - Edavanna Road, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/895580233",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 66
  },
  {
    "id": "osm-way-895528004",
    "slug": "kanayankode-juma-masjid-quilandy-thamarassery-edavanna-road-kozhikode",
    "nameEnglish": "Kanayankode Juma Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Quilandy - Thamarassery - Edavanna Road",
    "state": "Kerala",
    "addressLine1": "Kanayankode Juma Masjid, Quilandy - Thamarassery - Edavanna Road, Nadathalakkal colony, Koyilandy, Koyilandi, Kozhikode, Kerala, 673300, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.4444035,
    "longitude": 75.7278723,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kanayankode Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Quilandy - Thamarassery - Edavanna Road, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/895528004",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 67
  },
  {
    "id": "osm-node-5845040673",
    "slug": "karakkutty-juma-masjid-sarkarparamba-colony-kozhikode",
    "nameEnglish": "Karakkutty Juma Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Sarkarparamba Colony",
    "state": "Kerala",
    "addressLine1": "Karakkutty Juma Masjid, Karakkutti Murathumoola Poyilil Road, Sarkarparamba Colony, Kodiyathur, Kozhikode, Kerala, 673602, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.2859104,
    "longitude": 75.992585,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Karakkutty Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Sarkarparamba Colony, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/5845040673",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 68
  },
  {
    "id": "osm-node-5845040695",
    "slug": "salafi-juma-masjid-kodiyathur-cheruvadi-road-kozhikode",
    "nameEnglish": "Salafi Juma Masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Kodiyathur Cheruvadi Road",
    "state": "Kerala",
    "addressLine1": "Salafi Juma Masjid, Kodiyathur Cheruvadi Road, Chullikkaparamb, Kodiyathur, Kozhikode, Kerala, 673602, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.2802789,
    "longitude": 75.9865721,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Salafi Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Kodiyathur Cheruvadi Road, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/5845040695",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 69
  },
  {
    "id": "osm-relation-20021028",
    "slug": "akhund-mullah-shah-mosque-nowhatta-srinagar",
    "nameEnglish": "Akhund Mullah Shah Mosque",
    "nameUrdu": null,
    "city": "Srinagar",
    "district": "Nowhatta",
    "state": "Jammu and Kashmir",
    "addressLine1": "Akhund Mullah Shah Mosque, Makdoom Sahab Eastern Stairs, Gojwara, Nowhatta, Srinagar, Jammu and Kashmir, 190003, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 16:15",
    "latitude": 34.1035002,
    "longitude": 74.8170623,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Akhund Mullah Shah Mosque is an OpenStreetMap-listed mosque/place of worship in Nowhatta, Srinagar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:relation/20021028",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 70
  },
  {
    "id": "osm-way-676609274",
    "slug": "aali-masjid-eidgah-zoonimar-srinagar",
    "nameEnglish": "Aali Masjid Eidgah",
    "nameUrdu": null,
    "city": "Srinagar",
    "district": "Zoonimar",
    "state": "Jammu and Kashmir",
    "addressLine1": "Aali Masjid Eidgah, Dr. Ali Jan Road, Zoonimar, Said pora, Srinagar, Jammu and Kashmir, 190002, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 16:15",
    "latitude": 34.1047714,
    "longitude": 74.7941451,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Aali Masjid Eidgah is an OpenStreetMap-listed mosque/place of worship in Zoonimar, Srinagar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/676609274",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 71
  },
  {
    "id": "osm-way-460796437",
    "slug": "pathar-masjid-khoja-bazar-srinagar",
    "nameEnglish": "Pathar masjid",
    "nameUrdu": null,
    "city": "Srinagar",
    "district": "Khoja bazar",
    "state": "Jammu and Kashmir",
    "addressLine1": "Pathar masjid, Dalal Mohalla Road, Khoja bazar, Srinagar, Srinagar (South), Srinagar, Jammu and Kashmir, 190002, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 16:15",
    "latitude": 34.0918997,
    "longitude": 74.8057832,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Pathar masjid is an OpenStreetMap-listed mosque/place of worship in Khoja bazar, Srinagar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/460796437",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 72
  },
  {
    "id": "osm-way-1224728450",
    "slug": "dwaranda-masjid-six-mile-guwahati",
    "nameEnglish": "Dwaranda Masjid",
    "nameUrdu": null,
    "city": "Guwahati",
    "district": "Six Mile",
    "state": "Assam",
    "addressLine1": "Dwaranda Masjid, 3, Panjabari Road, Jaya Nagar, Six Mile, Guwahati, Dispur, Kamrup Metropolitan, Assam, 781027, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:48",
    "latitude": 26.1328211,
    "longitude": 91.8126716,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Dwaranda Masjid is an OpenStreetMap-listed mosque/place of worship in Six Mile, Guwahati. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1224728450",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 73
  },
  {
    "id": "osm-node-12976471295",
    "slug": "masjid-lane-fancy-bazaar-guwahati",
    "nameEnglish": "Masjid Lane",
    "nameUrdu": null,
    "city": "Guwahati",
    "district": "Fancy Bazaar",
    "state": "Assam",
    "addressLine1": "Masjid Lane, Hem Baruah Road, Fancy Bazaar, Guwahati, Kamrup Metropolitan, Assam, 781015, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:48",
    "latitude": 26.1822209,
    "longitude": 91.7407322,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid Lane is an OpenStreetMap-listed mosque/place of worship in Fancy Bazaar, Guwahati. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12976471295",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 74
  },
  {
    "id": "osm-node-12595597773",
    "slug": "islampur-masjid-and-madrassa-gandhi-basti-guwahati",
    "nameEnglish": "islampur masjid and madrassa",
    "nameUrdu": null,
    "city": "Guwahati",
    "district": "Gandhi Basti",
    "state": "Assam",
    "addressLine1": "islampur masjid and madrassa, Lalmati Road, Islumpur, Gandhi Basti, Guwahati, Kamrup Metropolitan, Assam, 781015, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:48",
    "latitude": 26.1807098,
    "longitude": 91.7591928,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "islampur masjid and madrassa is an OpenStreetMap-listed mosque/place of worship in Gandhi Basti, Guwahati. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12595597773",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 75
  },
  {
    "id": "osm-node-12976892549",
    "slug": "masjid-e-shaykh-ulubari-guwahati",
    "nameEnglish": "MASJID E SHAYKH",
    "nameUrdu": null,
    "city": "Guwahati",
    "district": "Ulubari",
    "state": "Assam",
    "addressLine1": "MASJID E SHAYKH, Ulubari Road, Gandh Basti, Ulubari, Guwahati, Kamrup Metropolitan, Assam, 781015, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:48",
    "latitude": 26.1750128,
    "longitude": 91.7598275,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "MASJID E SHAYKH is an OpenStreetMap-listed mosque/place of worship in Ulubari, Guwahati. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12976892549",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 76
  },
  {
    "id": "osm-node-10593493619",
    "slug": "paltan-masjid-paltan-bazar-guwahati",
    "nameEnglish": "Paltan Masjid",
    "nameUrdu": null,
    "city": "Guwahati",
    "district": "Paltan Bazar",
    "state": "Assam",
    "addressLine1": "Paltan Masjid, G.S. Road, Paltan Baazar, Islumpur, Paltan Bazar, Guwahati, Kamrup Metropolitan, Assam, 781001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:48",
    "latitude": 26.1805984,
    "longitude": 91.7487574,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Paltan Masjid is an OpenStreetMap-listed mosque/place of worship in Paltan Bazar, Guwahati. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/10593493619",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 77
  },
  {
    "id": "osm-node-7622938505",
    "slug": "mahdibagh-masjid-itwari-nagpur",
    "nameEnglish": "Mahdibagh Masjid",
    "nameUrdu": null,
    "city": "Nagpur",
    "district": "Itwari",
    "state": "Maharashtra",
    "addressLine1": "Mahdibagh Masjid, Mahdibagh Road, Itwari, Nagpur, Nagpur Urban Taluka, Nagpur, Maharashtra, 440017, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:32",
    "latitude": 21.1660521,
    "longitude": 79.1178274,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Mahdibagh Masjid is an OpenStreetMap-listed mosque/place of worship in Itwari, Nagpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7622938505",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 78
  },
  {
    "id": "osm-node-3141259111",
    "slug": "bhupesh-nagar-masjid-seminary-hills-nagpur",
    "nameEnglish": "Bhupesh Nagar Masjid",
    "nameUrdu": null,
    "city": "Nagpur",
    "district": "Seminary Hills",
    "state": "Maharashtra",
    "addressLine1": "Bhupesh Nagar Masjid, Katol Road, Raj Nagar, Seminary Hills, Nagpur, Nagpur Urban Taluka, Nagpur, Maharashtra, 440006, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:32",
    "latitude": 21.1801698,
    "longitude": 79.0553532,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Bhupesh Nagar Masjid is an OpenStreetMap-listed mosque/place of worship in Seminary Hills, Nagpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/3141259111",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 79
  },
  {
    "id": "osm-node-9822338084",
    "slug": "hakimi-masjid-itwari-nagpur",
    "nameEnglish": "Hakimi Masjid",
    "nameUrdu": null,
    "city": "Nagpur",
    "district": "Itwari",
    "state": "Maharashtra",
    "addressLine1": "Hakimi Masjid, Dahi Bazar Flyover, Itwari, Nagpur, Nagpur Urban Taluka, Nagpur, Maharashtra, 440017, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:32",
    "latitude": 21.1588075,
    "longitude": 79.121436,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Hakimi Masjid is an OpenStreetMap-listed mosque/place of worship in Itwari, Nagpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/9822338084",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 80
  },
  {
    "id": "osm-node-3143168358",
    "slug": "abu-miya-masjid-mominpura-nagpur",
    "nameEnglish": "Abu Miya Masjid",
    "nameUrdu": null,
    "city": "Nagpur",
    "district": "Mominpura",
    "state": "Maharashtra",
    "addressLine1": "Abu Miya Masjid, Chudi Gali, Mominpura, Nagpur, Nagpur Urban Taluka, Nagpur, Maharashtra, 440018, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:32",
    "latitude": 21.1600432,
    "longitude": 79.0947747,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Abu Miya Masjid is an OpenStreetMap-listed mosque/place of worship in Mominpura, Nagpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/3143168358",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 81
  },
  {
    "id": "osm-node-4682682590",
    "slug": "khoja-masjid-nagpur-adilabad-road-nagpur",
    "nameEnglish": "Khoja Masjid",
    "nameUrdu": null,
    "city": "Nagpur",
    "district": "Nagpur Adilabad Road",
    "state": "Maharashtra",
    "addressLine1": "Khoja Masjid, Nagpur Adilabad Road, Hinganghat, Wardha, Maharashtra, 442300, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:32",
    "latitude": 20.5501873,
    "longitude": 78.8328833,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Khoja Masjid is an OpenStreetMap-listed mosque/place of worship in Nagpur Adilabad Road, Nagpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/4682682590",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 82
  },
  {
    "id": "osm-way-455137002",
    "slug": "masjid-ul-moazzam-salabatpura-surat",
    "nameEnglish": "Masjid ul Moazzam",
    "nameUrdu": null,
    "city": "Surat",
    "district": "Salabatpura",
    "state": "Gujarat",
    "addressLine1": "Masjid ul Moazzam, Ashkta Ashram Road, Salabatpura, Surat, Gujarat, 395003, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:57",
    "latitude": 21.1945521,
    "longitude": 72.8320255,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid ul Moazzam is an OpenStreetMap-listed mosque/place of worship in Salabatpura, Surat. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/455137002",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 83
  },
  {
    "id": "osm-way-1305257267",
    "slug": "masjid-e-aarifiya-maslak-e-ahle-sunnat-wal-jama-at-shree-chandrashekhar-azad-fly",
    "nameEnglish": "Masjid e Aarifiya (Maslak e Ahle Sunnat Wal Jama'at)",
    "nameUrdu": null,
    "city": "Surat",
    "district": "Shree Chandrashekhar Azad Flyover",
    "state": "Gujarat",
    "addressLine1": "Masjid e Aarifiya (Maslak e Ahle Sunnat Wal Jama'at), Shree Chandrashekhar Azad Flyover, Surat, Gujarat, 392009, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:57",
    "latitude": 21.2030083,
    "longitude": 72.8065581,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid e Aarifiya (Maslak e Ahle Sunnat Wal Jama'at) is an OpenStreetMap-listed mosque/place of worship in Shree Chandrashekhar Azad Flyover, Surat. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1305257267",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 84
  },
  {
    "id": "osm-node-4636794634",
    "slug": "khubsaab-masjid-salabatpura-surat",
    "nameEnglish": "khubsaab masjid",
    "nameUrdu": null,
    "city": "Surat",
    "district": "Salabatpura",
    "state": "Gujarat",
    "addressLine1": "khubsaab masjid, toorawa street, Saiyedwada, Salabatpura, Surat, Gujarat, 395003, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:57",
    "latitude": 21.2029903,
    "longitude": 72.8282058,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "khubsaab masjid is an OpenStreetMap-listed mosque/place of worship in Salabatpura, Surat. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/4636794634",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 85
  },
  {
    "id": "osm-node-10181382965",
    "slug": "kosadi-masjid-juni-kosadi-sh166-surat",
    "nameEnglish": "Kosadi Masjid (Juni Kosadi)",
    "nameUrdu": null,
    "city": "Surat",
    "district": "SH166",
    "state": "Gujarat",
    "addressLine1": "Kosadi Masjid (Juni Kosadi), SH166, Mangrol Taluka, Surat, Gujarat, 394410, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:57",
    "latitude": 21.4724987,
    "longitude": 73.0998705,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kosadi Masjid (Juni Kosadi) is an OpenStreetMap-listed mosque/place of worship in SH166, Surat. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/10181382965",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 86
  },
  {
    "id": "osm-way-679004451",
    "slug": "darul-uloom-masjid-and-madarasa-ashwamegh-nagar-vadodara",
    "nameEnglish": "Darul Uloom - Masjid and Madarasa",
    "nameUrdu": null,
    "city": "Vadodara",
    "district": "Ashwamegh Nagar",
    "state": "Gujarat",
    "addressLine1": "Darul Uloom - Masjid and Madarasa, Vasna-Tandalja Road, Ashwamegh Nagar, Vadodara Rural Taluka, Vadodara, Gujarat, 390015, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 22.2900146,
    "longitude": 73.1463575,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Darul Uloom - Masjid and Madarasa is an OpenStreetMap-listed mosque/place of worship in Ashwamegh Nagar, Vadodara. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/679004451",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 87
  },
  {
    "id": "osm-node-7945422089",
    "slug": "masjid-e-raza-indrapuri-road-vadodara",
    "nameEnglish": "Masjid E Raza",
    "nameUrdu": null,
    "city": "Vadodara",
    "district": "indrapuri road",
    "state": "Gujarat",
    "addressLine1": "Masjid E Raza, indrapuri road, Vadodara Rural Taluka, Vadodara, Gujarat, 390019, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 22.3010472,
    "longitude": 73.2261509,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid E Raza is an OpenStreetMap-listed mosque/place of worship in indrapuri road, Vadodara. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7945422089",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 88
  },
  {
    "id": "osm-node-7642316961",
    "slug": "badi-masjid-alkapuri-vadodara",
    "nameEnglish": "Badi Masjid",
    "nameUrdu": null,
    "city": "Vadodara",
    "district": "Alkapuri",
    "state": "Gujarat",
    "addressLine1": "Badi Masjid, Sadar Bazar, Pramukh Swami Maharaj Flyover, Alkapuri, Vadodara, Vadodara Rural Taluka, Vadodara, Gujarat, 390008, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 22.3228013,
    "longitude": 73.1896418,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Badi Masjid is an OpenStreetMap-listed mosque/place of worship in Alkapuri, Vadodara. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7642316961",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 89
  },
  {
    "id": "osm-node-7642316967",
    "slug": "nani-masjid-alkapuri-vadodara",
    "nameEnglish": "Nani Masjid",
    "nameUrdu": null,
    "city": "Vadodara",
    "district": "Alkapuri",
    "state": "Gujarat",
    "addressLine1": "Nani Masjid, 501, Pramukh Swami Maharaj Flyover, Alkapuri, Vadodara, Vadodara Rural Taluka, Vadodara, Gujarat, 390008, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 22.3222551,
    "longitude": 73.1902303,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Nani Masjid is an OpenStreetMap-listed mosque/place of worship in Alkapuri, Vadodara. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7642316967",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 90
  },
  {
    "id": "osm-node-2345144103",
    "slug": "khane-rafaiya-masjid-nava-bazaar-vadodara",
    "nameEnglish": "Khane Rafaiya Masjid",
    "nameUrdu": null,
    "city": "Vadodara",
    "district": "Nava Bazaar",
    "state": "Gujarat",
    "addressLine1": "Khane Rafaiya Masjid, Dandia Bazaar Road, Nava Bazaar, Vadodara, Vadodara Rural Taluka, Vadodara, Gujarat, 390001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 22.2994661,
    "longitude": 73.1959004,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Khane Rafaiya Masjid is an OpenStreetMap-listed mosque/place of worship in Nava Bazaar, Vadodara. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/2345144103",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 91
  },
  {
    "id": "osm-way-1356693923",
    "slug": "shahi-masjid-kanpur-road-kanpur",
    "nameEnglish": "Shahi Masjid",
    "nameUrdu": null,
    "city": "Kanpur",
    "district": "kanpur Road",
    "state": "Uttar Pradesh",
    "addressLine1": "Shahi Masjid, kanpur Road, Transport Nagar, Aurangabad, Lucknow, Uttar Pradesh, 226012, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:34",
    "latitude": 26.7703818,
    "longitude": 80.9120437,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Shahi Masjid is an OpenStreetMap-listed mosque/place of worship in kanpur Road, Kanpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1356693923",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 92
  },
  {
    "id": "osm-way-1356694399",
    "slug": "aisha-masjid-kanpur-road-kanpur",
    "nameEnglish": "Aisha Masjid",
    "nameUrdu": null,
    "city": "Kanpur",
    "district": "kanpur Road",
    "state": "Uttar Pradesh",
    "addressLine1": "Aisha Masjid, kanpur Road, Transport Nagar, Aurangabad, Lucknow, Uttar Pradesh, 226012, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:34",
    "latitude": 26.7717195,
    "longitude": 80.9136472,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Aisha Masjid is an OpenStreetMap-listed mosque/place of worship in kanpur Road, Kanpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1356694399",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 93
  },
  {
    "id": "osm-way-1356694880",
    "slug": "noorani-masjid-kanpur-road-kanpur",
    "nameEnglish": "Noorani Masjid",
    "nameUrdu": null,
    "city": "Kanpur",
    "district": "kanpur Road",
    "state": "Uttar Pradesh",
    "addressLine1": "Noorani Masjid, kanpur Road, Transport Nagar, Aurangabad, Lucknow, Uttar Pradesh, 226012, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:34",
    "latitude": 26.7725399,
    "longitude": 80.9151492,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Noorani Masjid is an OpenStreetMap-listed mosque/place of worship in kanpur Road, Kanpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1356694880",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 94
  },
  {
    "id": "osm-node-9463750540",
    "slug": "masjid-sheikh-humayon-the-mall-road-kanpur",
    "nameEnglish": "masjid sheikh humayon",
    "nameUrdu": null,
    "city": "Kanpur",
    "district": "The Mall Road",
    "state": "Uttar Pradesh",
    "addressLine1": "masjid sheikh humayon, The Mall Road, Kanpur, Kanpur Nagar, Uttar Pradesh, 208012, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:34",
    "latitude": 26.4742242,
    "longitude": 80.3357433,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "masjid sheikh humayon is an OpenStreetMap-listed mosque/place of worship in The Mall Road, Kanpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/9463750540",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 95
  },
  {
    "id": "osm-node-11652935995",
    "slug": "bansmandi-masjid-halsey-road-kanpur",
    "nameEnglish": "BANSMANDI MASJID",
    "nameUrdu": null,
    "city": "Kanpur",
    "district": "Halsey Road",
    "state": "Uttar Pradesh",
    "addressLine1": "BANSMANDI MASJID, Halsey Road, Kanpur, Kanpur Nagar, Uttar Pradesh, 208012, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:34",
    "latitude": 26.4622266,
    "longitude": 80.3408725,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "BANSMANDI MASJID is an OpenStreetMap-listed mosque/place of worship in Halsey Road, Kanpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/11652935995",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 96
  },
  {
    "id": "osm-way-295336827",
    "slug": "gyanvapi-mosque-tripura-bhairwi-varanasi",
    "nameEnglish": "Gyanvapi Mosque",
    "nameUrdu": null,
    "city": "Varanasi",
    "district": "Tripura Bhairwi",
    "state": "Uttar Pradesh",
    "addressLine1": "Gyanvapi Mosque, Tripura Bhairwi, Banaras Ghats, Varanasi, Uttar Pradesh, 221001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:20",
    "latitude": 25.3112589,
    "longitude": 83.0104224,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Gyanvapi Mosque is an OpenStreetMap-listed mosque/place of worship in Tripura Bhairwi, Varanasi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/295336827",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 97
  },
  {
    "id": "osm-way-516960093",
    "slug": "iqra-masjid-konka-ranchi",
    "nameEnglish": "Iqra Masjid",
    "nameUrdu": null,
    "city": "Ranchi",
    "district": "Konka",
    "state": "Jharkhand",
    "addressLine1": "Iqra Masjid, Hinpidi Gali, Konka, Ranchi, Kanke, Ranchi, Jharkhand, 834001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:05",
    "latitude": 23.3602931,
    "longitude": 85.3257196,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Iqra Masjid is an OpenStreetMap-listed mosque/place of worship in Konka, Ranchi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/516960093",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 98
  },
  {
    "id": "osm-node-9289111550",
    "slug": "masjid-e-hera-konka-ranchi",
    "nameEnglish": "masjid e hera",
    "nameUrdu": null,
    "city": "Ranchi",
    "district": "Konka",
    "state": "Jharkhand",
    "addressLine1": "masjid e hera, millat colony pathal kudwa ranchi, Purluia Road, Konka, Ranchi, Kanke, Ranchi, Jharkhand, 834001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:05",
    "latitude": 23.3666826,
    "longitude": 85.3373817,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "masjid e hera is an OpenStreetMap-listed mosque/place of worship in Konka, Ranchi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/9289111550",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 99
  },
  {
    "id": "osm-way-1363487960",
    "slug": "jeppu-kuppadi-mosque-attavar-mangaluru",
    "nameEnglish": "Jeppu Kuppadi Mosque",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Attavar",
    "state": "Karnataka",
    "addressLine1": "Jeppu Kuppadi Mosque, Jeppu Kuppadi Road, Nandigudda, Attavar, Mangaluru, Mangaluru taluk, Dakshina Kannada, Karnataka, 575001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 12.8522932,
    "longitude": 74.8555161,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jeppu Kuppadi Mosque is an OpenStreetMap-listed mosque/place of worship in Attavar, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1363487960",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 100
  },
  {
    "id": "osm-node-1750872481",
    "slug": "bolar-mosque-bolar-mangaluru",
    "nameEnglish": "Bolar Mosque",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Bolar",
    "state": "Karnataka",
    "addressLine1": "Bolar Mosque, Subhas Nagar, 2nd Cross, Bolar, Mangaluru, Mangaluru taluk, Dakshina Kannada, Karnataka, 575001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 12.8476249,
    "longitude": 74.8403287,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Bolar Mosque is an OpenStreetMap-listed mosque/place of worship in Bolar, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/1750872481",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 101
  },
  {
    "id": "osm-way-466918224",
    "slug": "jamma-masjid-kudroli-mangaluru",
    "nameEnglish": "Jamma Masjid",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Kudroli",
    "state": "Karnataka",
    "addressLine1": "Jamma Masjid, Bhoja Rao Lane, Bokkapatna, Kudroli, Mangaluru, Mangaluru taluk, Dakshina Kannada, Karnataka, 575001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 12.8777581,
    "longitude": 74.8293339,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamma Masjid is an OpenStreetMap-listed mosque/place of worship in Kudroli, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/466918224",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 102
  },
  {
    "id": "osm-way-849833693",
    "slug": "eidgah-jumma-masjid-krishnapura-mangaluru",
    "nameEnglish": "Eidgah Jumma Masjid",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Krishnapura",
    "state": "Karnataka",
    "addressLine1": "Eidgah Jumma Masjid, Krishnapura Road, Krishnapura, Surathkal, Mangaluru taluk, Dakshina Kannada, Karnataka, 575014, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 12.9920891,
    "longitude": 74.8135885,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Eidgah Jumma Masjid is an OpenStreetMap-listed mosque/place of worship in Krishnapura, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/849833693",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 103
  },
  {
    "id": "osm-way-910870903",
    "slug": "nadupalli-jumma-masjid-kudroli-mangaluru",
    "nameEnglish": "Nadupalli Jumma Masjid",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Kudroli",
    "state": "Karnataka",
    "addressLine1": "Nadupalli Jumma Masjid, Kudroli Road, Bokkapatna, Kudroli, Mangaluru, Mangaluru taluk, Dakshina Kannada, Karnataka, 575001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 12.8761746,
    "longitude": 74.8296853,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Nadupalli Jumma Masjid is an OpenStreetMap-listed mosque/place of worship in Kudroli, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/910870903",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 104
  },
  {
    "id": "osm-node-8196831219",
    "slug": "mohiyuddin-juma-masjid-maarigudi-road-mangaluru",
    "nameEnglish": "Mohiyuddin Juma Masjid",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Maarigudi Road",
    "state": "Karnataka",
    "addressLine1": "Mohiyuddin Juma Masjid, Maarigudi Road, Surathkal, Mangaluru taluk, Dakshina Kannada, Karnataka, 575014, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 12.9897138,
    "longitude": 74.7972004,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Mohiyuddin Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Maarigudi Road, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196831219",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 105
  },
  {
    "id": "osm-node-8196831362",
    "slug": "kavoor-jumma-masjid-kavoor-mangaluru",
    "nameEnglish": "Kavoor Jumma Masjid",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Kavoor",
    "state": "Karnataka",
    "addressLine1": "Kavoor Jumma Masjid, Airport Road, Kavoor, Bondel, Mangaluru taluk, Dakshina Kannada, Karnataka, 575015, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 12.9265807,
    "longitude": 74.8585465,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kavoor Jumma Masjid is an OpenStreetMap-listed mosque/place of worship in Kavoor, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196831362",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 106
  },
  {
    "id": "osm-node-8196836386",
    "slug": "jamiya-masjid-solapur-mangalore-highway-mangaluru",
    "nameEnglish": "Jamiya Masjid",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Solapur-Mangalore Highway",
    "state": "Karnataka",
    "addressLine1": "Jamiya Masjid, Solapur-Mangalore Highway, Kesaragadde, Moodabidri taluk, Dakshina Kannada, Karnataka, 574227, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 13.0976807,
    "longitude": 75.0069592,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiya Masjid is an OpenStreetMap-listed mosque/place of worship in Solapur-Mangalore Highway, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196836386",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 107
  },
  {
    "id": "osm-node-8196834234",
    "slug": "jamiya-masjid-bylakuppe-tibetan-settlement-mysuru",
    "nameEnglish": "Jamiya Masjid",
    "nameUrdu": null,
    "city": "Mysuru",
    "district": "Bylakuppe Tibetan Settlement",
    "state": "Karnataka",
    "addressLine1": "Jamiya Masjid, NH275, Bylakuppe Tibetan Settlement, Koppa, Piriyapattana taluk, Mysuru District, Karnataka, 571104, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:49",
    "latitude": 12.4277128,
    "longitude": 75.9967446,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiya Masjid is an OpenStreetMap-listed mosque/place of worship in Bylakuppe Tibetan Settlement, Mysuru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196834234",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 108
  },
  {
    "id": "osm-node-8196833566",
    "slug": "jamiya-masjid-sh108-mysuru",
    "nameEnglish": "Jamiya Masjid",
    "nameUrdu": null,
    "city": "Mysuru",
    "district": "SH108",
    "state": "Karnataka",
    "addressLine1": "Jamiya Masjid, SH108, Saligrama, Saligrama taluku, Mysuru District, Karnataka, 571604, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:49",
    "latitude": 12.560802,
    "longitude": 76.2621787,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiya Masjid is an OpenStreetMap-listed mosque/place of worship in SH108, Mysuru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196833566",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 109
  },
  {
    "id": "osm-node-8196833797",
    "slug": "jamiya-masjid-sh21-mysuru",
    "nameEnglish": "Jamiya Masjid",
    "nameUrdu": null,
    "city": "Mysuru",
    "district": "SH21",
    "state": "Karnataka",
    "addressLine1": "Jamiya Masjid, SH21, ಸುರಗಹಳ್ಳಿ, Halaganahalli, Piriyapattana taluk, Mysuru District, Karnataka, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:49",
    "latitude": 12.5251183,
    "longitude": 76.0888735,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiya Masjid is an OpenStreetMap-listed mosque/place of worship in SH21, Mysuru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196833797",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 110
  },
  {
    "id": "osm-node-8196833941",
    "slug": "jamiya-masjid-sh86-mysuru",
    "nameEnglish": "Jamiya Masjid",
    "nameUrdu": null,
    "city": "Mysuru",
    "district": "SH86",
    "state": "Karnataka",
    "addressLine1": "Jamiya Masjid, SH86, Hosuru, Saligrama taluku, Mysuru District, Karnataka, 571617, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:49",
    "latitude": 12.5005342,
    "longitude": 76.269641,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiya Masjid is an OpenStreetMap-listed mosque/place of worship in SH86, Mysuru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196833941",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 111
  },
  {
    "id": "osm-node-8196836315",
    "slug": "jamia-masjid-bodyguard-k-c-layout-mysuru",
    "nameEnglish": "Jamia Masjid (bodyguard)",
    "nameUrdu": null,
    "city": "Mysuru",
    "district": "K C Layout",
    "state": "Karnataka",
    "addressLine1": "Jamia Masjid (bodyguard), Chamundi Hill Road, K C Layout, Mysuru, Mysuru taluk, Mysuru District, Karnataka, 570001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:49",
    "latitude": 12.2969317,
    "longitude": 76.6786483,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamia Masjid (bodyguard) is an OpenStreetMap-listed mosque/place of worship in K C Layout, Mysuru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196836315",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 112
  },
  {
    "id": "osm-way-343152072",
    "slug": "masjid-mosque-devi-nagar-vijayawada",
    "nameEnglish": "Masjid (mosque)",
    "nameUrdu": null,
    "city": "Vijayawada",
    "district": "Devi Nagar",
    "state": "Andhra Pradesh",
    "addressLine1": "Masjid (mosque), Karl Marx Road, Machavaram, Devi Nagar, Vijayawada, Vijayawada (Urban), NTR, Andhra Pradesh, 520001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:30",
    "latitude": 16.524235,
    "longitude": 80.6584071,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid (mosque) is an OpenStreetMap-listed mosque/place of worship in Devi Nagar, Vijayawada. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/343152072",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 113
  },
  {
    "id": "osm-node-12993684424",
    "slug": "muslim-mosque-enikepadu-vijayawada",
    "nameEnglish": "Muslim Mosque",
    "nameUrdu": null,
    "city": "Vijayawada",
    "district": "Enikepadu",
    "state": "Andhra Pradesh",
    "addressLine1": "Muslim Mosque, Nidamanuru Main Road, Nidamanuru, Enikepadu, Nidamanuru, Vijayawada (Rural), NTR, Andhra Pradesh, 521104, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:30",
    "latitude": 16.5094408,
    "longitude": 80.7225622,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Muslim Mosque is an OpenStreetMap-listed mosque/place of worship in Enikepadu, Vijayawada. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12993684424",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 114
  },
  {
    "id": "osm-way-963222672",
    "slug": "mahmoud-mosque-jail-road-aligarh",
    "nameEnglish": "MAHMOUD MOSQUE",
    "nameUrdu": null,
    "city": "Aligarh",
    "district": "Jail Road",
    "state": "Uttar Pradesh",
    "addressLine1": "MAHMOUD MOSQUE, Jail Road, Aligarh, Koil, Aligarh, Uttar Pradesh, 202001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 27.8977223,
    "longitude": 78.0725682,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "MAHMOUD MOSQUE is an OpenStreetMap-listed mosque/place of worship in Jail Road, Aligarh. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/963222672",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 115
  },
  {
    "id": "osm-way-963223059",
    "slug": "dargah-hazrat-masoom-mosque-jail-road-aligarh",
    "nameEnglish": "DARGAH HAZRAT MASOOM MOSQUE",
    "nameUrdu": null,
    "city": "Aligarh",
    "district": "Jail Road",
    "state": "Uttar Pradesh",
    "addressLine1": "DARGAH HAZRAT MASOOM MOSQUE, Jail Road, Aligarh, Koil, Aligarh, Uttar Pradesh, 202001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 27.8974106,
    "longitude": 78.0720343,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "DARGAH HAZRAT MASOOM MOSQUE is an OpenStreetMap-listed mosque/place of worship in Jail Road, Aligarh. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/963223059",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 116
  },
  {
    "id": "osm-way-963223218",
    "slug": "mosque-dargah-hazrat-masoom-miyan-rahmatullah-tala-aliah-jail-road-aligarh",
    "nameEnglish": "MOSQUE DARGAH HAZRAT MASOOM MIYAN RAHMATULLAH TALA ALIAH",
    "nameUrdu": null,
    "city": "Aligarh",
    "district": "Jail Road",
    "state": "Uttar Pradesh",
    "addressLine1": "MOSQUE DARGAH HAZRAT MASOOM MIYAN RAHMATULLAH TALA ALIAH, Jail Road, Aligarh, Koil, Aligarh, Uttar Pradesh, 202001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 27.8973936,
    "longitude": 78.0723661,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "MOSQUE DARGAH HAZRAT MASOOM MIYAN RAHMATULLAH TALA ALIAH is an OpenStreetMap-listed mosque/place of worship in Jail Road, Aligarh. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/963223218",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 117
  },
  {
    "id": "osm-node-11830270315",
    "slug": "masjid-e-umar-aligarh-bypass-aligarh",
    "nameEnglish": "Masjid-e-umar",
    "nameUrdu": null,
    "city": "Aligarh",
    "district": "Aligarh Bypass",
    "state": "Uttar Pradesh",
    "addressLine1": "Masjid-e-umar, Aligarh Bypass, Aligarh, Koil, Aligarh, Uttar Pradesh, 202001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 27.925727,
    "longitude": 78.0931033,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid-e-umar is an OpenStreetMap-listed mosque/place of worship in Aligarh Bypass, Aligarh. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/11830270315",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 118
  },
  {
    "id": "osm-way-1168906278",
    "slug": "quile-wali-masjid-gmd-road-moradabad",
    "nameEnglish": "Quile Wali Masjid",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "GMD Road",
    "state": "Uttar Pradesh",
    "addressLine1": "Quile Wali Masjid, GMD Road, Moradabad, Uttar Pradesh, 244001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 28.8359047,
    "longitude": 78.7886733,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Quile Wali Masjid is an OpenStreetMap-listed mosque/place of worship in GMD Road, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1168906278",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 119
  },
  {
    "id": "osm-node-13911318001",
    "slug": "kait-wali-masjid-sh49-moradabad",
    "nameEnglish": "Kait Wali Masjid",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "SH49",
    "state": "Uttar Pradesh",
    "addressLine1": "Kait Wali Masjid, SH49, Moradabad, Uttar Pradesh, 244001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 28.8277485,
    "longitude": 78.7883094,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kait Wali Masjid is an OpenStreetMap-listed mosque/place of worship in SH49, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13911318001",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 120
  },
  {
    "id": "osm-node-13911318002",
    "slug": "imli-wali-masjid-sh49-moradabad",
    "nameEnglish": "Imli Wali Masjid",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "SH49",
    "state": "Uttar Pradesh",
    "addressLine1": "Imli Wali Masjid, SH49, Moradabad, Uttar Pradesh, 244001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 28.8270571,
    "longitude": 78.7864074,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Imli Wali Masjid is an OpenStreetMap-listed mosque/place of worship in SH49, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13911318002",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 121
  },
  {
    "id": "osm-node-13911318101",
    "slug": "noor-wali-masjid-sh49-moradabad",
    "nameEnglish": "Noor Wali Masjid",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "SH49",
    "state": "Uttar Pradesh",
    "addressLine1": "Noor Wali Masjid, SH49, Moradabad, Uttar Pradesh, 244001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 28.8275719,
    "longitude": 78.7871974,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Noor Wali Masjid is an OpenStreetMap-listed mosque/place of worship in SH49, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13911318101",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 122
  },
  {
    "id": "osm-node-13911327701",
    "slug": "chabutre-wali-masjid-gmd-road-moradabad",
    "nameEnglish": "Chabutre Wali Masjid",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "GMD Road",
    "state": "Uttar Pradesh",
    "addressLine1": "Chabutre Wali Masjid, GMD Road, Moradabad, Uttar Pradesh, 244001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 28.8292425,
    "longitude": 78.7873818,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Chabutre Wali Masjid is an OpenStreetMap-listed mosque/place of worship in GMD Road, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13911327701",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 123
  },
  {
    "id": "osm-node-13911327901",
    "slug": "chand-wali-masjid-prince-road-moradabad-gmd-road-moradabad",
    "nameEnglish": "Chand Wali Masjid, Prince Road, Moradabad",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "GMD Road",
    "state": "Uttar Pradesh",
    "addressLine1": "Chand Wali Masjid, Prince Road, Moradabad, GMD Road, Moradabad, Uttar Pradesh, 244001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 28.8301971,
    "longitude": 78.7833847,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Chand Wali Masjid, Prince Road, Moradabad is an OpenStreetMap-listed mosque/place of worship in GMD Road, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13911327901",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 124
  },
  {
    "id": "osm-node-13911317803",
    "slug": "roze-wali-masjid-moradabad-gmd-road-moradabad",
    "nameEnglish": "Roze Wali Masjid, Moradabad",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "GMD Road",
    "state": "Uttar Pradesh",
    "addressLine1": "Roze Wali Masjid, Moradabad, GMD Road, Moradabad, Uttar Pradesh, 244001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 28.8283687,
    "longitude": 78.7872484,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Roze Wali Masjid, Moradabad is an OpenStreetMap-listed mosque/place of worship in GMD Road, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13911317803",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 125
  },
  {
    "id": "osm-node-13845417851",
    "slug": "khanqah-masjid-mdr150w-moradabad",
    "nameEnglish": "Khanqah Masjid",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "MDR150W",
    "state": "Uttar Pradesh",
    "addressLine1": "Khanqah Masjid, MDR150W, Umri Kalan, Moradabad, Amroha, Uttar Pradesh, 244501, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 29.0357646,
    "longitude": 78.5661158,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Khanqah Masjid is an OpenStreetMap-listed mosque/place of worship in MDR150W, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13845417851",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 126
  },
  {
    "id": "osm-node-13845417852",
    "slug": "masjid-qureshiyan-mdr150w-moradabad",
    "nameEnglish": "Masjid Qureshiyan",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "MDR150W",
    "state": "Uttar Pradesh",
    "addressLine1": "Masjid Qureshiyan, MDR150W, Umri Kalan, Moradabad, Amroha, Uttar Pradesh, 244501, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 29.0380637,
    "longitude": 78.5653907,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid Qureshiyan is an OpenStreetMap-listed mosque/place of worship in MDR150W, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13845417852",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 127
  },
  {
    "id": "osm-node-13845369468",
    "slug": "diwan-masjid-mdr150w-moradabad",
    "nameEnglish": "Diwan Masjid",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "MDR150W",
    "state": "Uttar Pradesh",
    "addressLine1": "Diwan Masjid, MDR150W, Umri Kalan, Moradabad, Amroha, Uttar Pradesh, 244501, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 29.0390588,
    "longitude": 78.5650933,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Diwan Masjid is an OpenStreetMap-listed mosque/place of worship in MDR150W, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13845369468",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 128
  },
  {
    "id": "osm-node-13335495316",
    "slug": "masjid-al-aqsa-state-highway-19-malegaon",
    "nameEnglish": "Masjid - Al -Aqsa",
    "nameUrdu": null,
    "city": "Malegaon",
    "district": "State Highway 19",
    "state": "Maharashtra",
    "addressLine1": "Masjid - Al -Aqsa, State Highway 19, Malegaon, Malegaon Taluka, Nashik District, Maharashtra, 423200, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:51",
    "latitude": 20.5486827,
    "longitude": 74.5019155,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid - Al -Aqsa is an OpenStreetMap-listed mosque/place of worship in State Highway 19, Malegaon. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13335495316",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 129
  },
  {
    "id": "osm-way-1489328262",
    "slug": "sunni-jama-masjid-deolali-camp-nashik",
    "nameEnglish": "Sunni Jama Masjid",
    "nameUrdu": null,
    "city": "Nashik",
    "district": "Deolali Camp",
    "state": "Maharashtra",
    "addressLine1": "Sunni Jama Masjid, Mithai Street, Deolali Market, Deolali Camp, Nashik, Nashik Subdistrict, Nashik District, Maharashtra, 422001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 19.9026622,
    "longitude": 73.8289956,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Sunni Jama Masjid is an OpenStreetMap-listed mosque/place of worship in Deolali Camp, Nashik. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1489328262",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 130
  },
  {
    "id": "osm-node-13671617188",
    "slug": "kokni-masjid-old-agra-road-nashik",
    "nameEnglish": "Kokni Masjid",
    "nameUrdu": null,
    "city": "Nashik",
    "district": "Old Agra Road",
    "state": "Maharashtra",
    "addressLine1": "Kokni Masjid, Old Agra Road, Igatpuri, Igatpuri Subdistrict, Nashik District, Maharashtra, 422403, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 19.6955781,
    "longitude": 73.5597655,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kokni Masjid is an OpenStreetMap-listed mosque/place of worship in Old Agra Road, Nashik. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13671617188",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 131
  },
  {
    "id": "osm-node-13671629195",
    "slug": "arab-masjid-igatpuri-old-agra-road-nashik",
    "nameEnglish": "Arab Masjid, Igatpuri",
    "nameUrdu": null,
    "city": "Nashik",
    "district": "Old Agra Road",
    "state": "Maharashtra",
    "addressLine1": "Arab Masjid, Igatpuri, Old Agra Road, Igatpuri, Igatpuri Subdistrict, Nashik District, Maharashtra, 422403, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 19.6971229,
    "longitude": 73.5611185,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Arab Masjid, Igatpuri is an OpenStreetMap-listed mosque/place of worship in Old Agra Road, Nashik. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13671629195",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 132
  },
  {
    "id": "osm-way-519235869",
    "slug": "masjid-e-rehmaniya-cantonment-aurangabad",
    "nameEnglish": "Masjid-e-Rehmaniya",
    "nameUrdu": null,
    "city": "Aurangabad",
    "district": "Cantonment",
    "state": "Maharashtra",
    "addressLine1": "Masjid-e-Rehmaniya, Railway Station Flyover, Cantonment, Chhatrapati Sambhajinagar, Chhatrapati Sambhajinagar District, Maharashtra, 431002, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 19.8574224,
    "longitude": 75.3036702,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid-e-Rehmaniya is an OpenStreetMap-listed mosque/place of worship in Cantonment, Aurangabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/519235869",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 133
  },
  {
    "id": "osm-node-12615173581",
    "slug": "jama-masjid-railway-station-cantonment-aurangabad",
    "nameEnglish": "Jama Masjid Railway Station",
    "nameUrdu": null,
    "city": "Aurangabad",
    "district": "Cantonment",
    "state": "Maharashtra",
    "addressLine1": "Jama Masjid Railway Station, Railway Station Flyover, Cantonment, Chhatrapati Sambhajinagar, Chhatrapati Sambhajinagar District, Maharashtra, 431002, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 19.861276,
    "longitude": 75.3100179,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jama Masjid Railway Station is an OpenStreetMap-listed mosque/place of worship in Cantonment, Aurangabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12615173581",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 134
  },
  {
    "id": "osm-way-1024520301",
    "slug": "the-mosque-seawoods-east-thane",
    "nameEnglish": "The Mosque",
    "nameUrdu": null,
    "city": "Thane",
    "district": "Seawoods East",
    "state": "Maharashtra",
    "addressLine1": "The Mosque, Dattatray Tandel Marg, Sector-50(E), Seawoods East, Navi Mumbai, Thane Subdistrict, Thane, Maharashtra, 400706, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:59",
    "latitude": 19.0161593,
    "longitude": 73.0222157,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "The Mosque is an OpenStreetMap-listed mosque/place of worship in Seawoods East, Thane. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1024520301",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 135
  },
  {
    "id": "osm-way-352790715",
    "slug": "jama-masjid-al-shams-mira-thane",
    "nameEnglish": "Jama Masjid Al Shams",
    "nameUrdu": null,
    "city": "Thane",
    "district": "Mira",
    "state": "Maharashtra",
    "addressLine1": "Jama Masjid Al Shams, Shrikant Dhadwe Road, Shanti Nagar, Mira, Mira-Bhayander, Thane Subdistrict, Thane, Maharashtra, 401107, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:59",
    "latitude": 19.2842615,
    "longitude": 72.8571652,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jama Masjid Al Shams is an OpenStreetMap-listed mosque/place of worship in Mira, Thane. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/352790715",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 136
  },
  {
    "id": "osm-node-8196832078",
    "slug": "masjid-e-usman-rajapura-kalaburagi",
    "nameEnglish": "Masjid E Usman",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Rajapura",
    "state": "Karnataka",
    "addressLine1": "Masjid E Usman, Ring Road, Rajapura, Nijampura, Kalaburagi taluku, Kalaburagi, Karnataka, 585104, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3396806,
    "longitude": 76.8594342,
    "facilities": [
      "Prayer Hall",
      "Wheelchair access"
    ],
    "description": "Masjid E Usman is an OpenStreetMap-listed mosque/place of worship in Rajapura, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832078",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 137
  },
  {
    "id": "osm-node-8196832117",
    "slug": "madina-masjid-hirapura-kalaburagi",
    "nameEnglish": "Madina Masjid",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Hirapura",
    "state": "Karnataka",
    "addressLine1": "Madina Masjid, MSK Mills Road, Hirapura, Kalaburagi, Kalaburagi taluku, Kalaburagi, Karnataka, 585101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3268568,
    "longitude": 76.8199025,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Madina Masjid is an OpenStreetMap-listed mosque/place of worship in Hirapura, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832117",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 138
  },
  {
    "id": "osm-node-8196832036",
    "slug": "masjid-e-bilal-mehbub-nagar-kalaburagi",
    "nameEnglish": "Masjid E Bilal",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Mehbub Nagar",
    "state": "Karnataka",
    "addressLine1": "Masjid E Bilal, Nehru Ganj, Mehbub Nagar, Nijampura, Kalaburagi taluku, Kalaburagi, Karnataka, 585104, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3525636,
    "longitude": 76.8496174,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid E Bilal is an OpenStreetMap-listed mosque/place of worship in Mehbub Nagar, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832036",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 139
  },
  {
    "id": "osm-node-8196832041",
    "slug": "noorani-masjid-hirapura-kalaburagi",
    "nameEnglish": "Noorani Masjid",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Hirapura",
    "state": "Karnataka",
    "addressLine1": "Noorani Masjid, Ring Road, Hirapura, Kalaburagi, Kalaburagi taluku, Kalaburagi, Karnataka, 585101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3504297,
    "longitude": 76.7998939,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Noorani Masjid is an OpenStreetMap-listed mosque/place of worship in Hirapura, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832041",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 140
  },
  {
    "id": "osm-node-8196832077",
    "slug": "lalgiri-masjid-fort-kalaburagi",
    "nameEnglish": "Lalgiri Masjid",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Fort",
    "state": "Karnataka",
    "addressLine1": "Lalgiri Masjid, By Road, Fort, Kalaburagi, Kalaburagi taluku, Kalaburagi, Karnataka, 585101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3398431,
    "longitude": 76.8240009,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Lalgiri Masjid is an OpenStreetMap-listed mosque/place of worship in Fort, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832077",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 141
  },
  {
    "id": "osm-node-8196832107",
    "slug": "jamia-masjid-ahle-sunnatul-jamat-hirapura-kalaburagi",
    "nameEnglish": "Jamia Masjid Ahle -sunnatul-jamat",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Hirapura",
    "state": "Karnataka",
    "addressLine1": "Jamia Masjid Ahle -sunnatul-jamat, MSK Mills Road, Hirapura, Kalaburagi, Kalaburagi taluku, Kalaburagi, Karnataka, 585101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3327646,
    "longitude": 76.8151965,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamia Masjid Ahle -sunnatul-jamat is an OpenStreetMap-listed mosque/place of worship in Hirapura, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832107",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 142
  },
  {
    "id": "osm-node-8196832083",
    "slug": "peer-buqari-masjid-rauza-kalaburagi",
    "nameEnglish": "Peer Buqari Masjid",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Rauza",
    "state": "Karnataka",
    "addressLine1": "Peer Buqari Masjid, Dargah Road, Rauza, Kalaburagi, Kalaburagi taluku, Kalaburagi, Karnataka, 585101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3379792,
    "longitude": 76.8494936,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Peer Buqari Masjid is an OpenStreetMap-listed mosque/place of worship in Rauza, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832083",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 143
  },
  {
    "id": "osm-node-8196832108",
    "slug": "masjid-e-abdul-hameed-ahle-hadees-rajapura-kalaburagi",
    "nameEnglish": "Masjid -e- Abdul Hameed (ahle Hadees)",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Rajapura",
    "state": "Karnataka",
    "addressLine1": "Masjid -e- Abdul Hameed (ahle Hadees), Sedam Road, Rajapura, Kalaburagi, Kalaburagi taluku, Kalaburagi, Karnataka, 585101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3326277,
    "longitude": 76.8478336,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid -e- Abdul Hameed (ahle Hadees) is an OpenStreetMap-listed mosque/place of worship in Rajapura, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832108",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 144
  },
  {
    "id": "osm-node-8196832102",
    "slug": "masjid-e-quba-ahle-hadees-rajapura-kalaburagi",
    "nameEnglish": "Masjid-e-quba (ahle Hadees)",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Rajapura",
    "state": "Karnataka",
    "addressLine1": "Masjid-e-quba (ahle Hadees), Ring Road, Rajapura, Nijampura, Kalaburagi taluku, Kalaburagi, Karnataka, 585104, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3334285,
    "longitude": 76.8584009,
    "facilities": [
      "Prayer Hall",
      "Wheelchair access"
    ],
    "description": "Masjid-e-quba (ahle Hadees) is an OpenStreetMap-listed mosque/place of worship in Rajapura, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832102",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 145
  },
  {
    "id": "osm-node-8196832046",
    "slug": "noorani-masjid-mehbub-nagar-kalaburagi",
    "nameEnglish": "Noorani Masjid",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Mehbub Nagar",
    "state": "Karnataka",
    "addressLine1": "Noorani Masjid, SH149, Mehbub Nagar, Kalaburagi, Kalaburagi taluku, Kalaburagi, Karnataka, 585101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3476314,
    "longitude": 76.857792,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Noorani Masjid is an OpenStreetMap-listed mosque/place of worship in Mehbub Nagar, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832046",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 146
  },
  {
    "id": "osm-node-8196831798",
    "slug": "jamiya-mosque-othagi-dhubalagundi-bidar",
    "nameEnglish": "Jamiya Mosque Othagi",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Dhubalagundi",
    "state": "Karnataka",
    "addressLine1": "Jamiya Mosque Othagi, SH75, Dhubalagundi, Dubalagundi, Chittaguppa taluku, Bidar, Karnataka, 585418, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 17.8774588,
    "longitude": 77.1611526,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiya Mosque Othagi is an OpenStreetMap-listed mosque/place of worship in Dhubalagundi, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196831798",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 147
  },
  {
    "id": "osm-node-8196832790",
    "slug": "jamiya-mosque-desangi-bidar-lakshmisagara-highway-bidar",
    "nameEnglish": "Jamiya Mosque Desangi",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Bidar - Lakshmisagara Highway",
    "state": "Karnataka",
    "addressLine1": "Jamiya Mosque Desangi, Bidar - Lakshmisagara Highway, Moratagi, Jevargi taluku, Kalaburagi, Karnataka, 586123, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 16.9694563,
    "longitude": 76.4163746,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiya Mosque Desangi is an OpenStreetMap-listed mosque/place of worship in Bidar - Lakshmisagara Highway, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832790",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 148
  },
  {
    "id": "osm-node-8196832919",
    "slug": "madina-mosque-sindagi-road-bidar",
    "nameEnglish": "Madina Mosque",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Sindagi Road",
    "state": "Karnataka",
    "addressLine1": "Madina Mosque, Sindagi Road, Hadagali, Bijapur Taluk, Vijayapura, Karnataka, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 16.8190928,
    "longitude": 75.9798752,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Madina Mosque is an OpenStreetMap-listed mosque/place of worship in Sindagi Road, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832919",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 149
  },
  {
    "id": "osm-way-260765652",
    "slug": "solah-khamba-masjid-multani-colony-bidar",
    "nameEnglish": "Solah Khamba Masjid",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Multani Colony",
    "state": "Karnataka",
    "addressLine1": "Solah Khamba Masjid, Qila Road, Multani Colony, Kabiravada, Bidar, Bidar taluku, Bidar, Karnataka, 585400, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 17.9208757,
    "longitude": 77.5280708,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Solah Khamba Masjid is an OpenStreetMap-listed mosque/place of worship in Multani Colony, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/260765652",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 150
  },
  {
    "id": "osm-node-8196831784",
    "slug": "bilal-masjid-mailura-bidar",
    "nameEnglish": "Bilal Masjid",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Mailura",
    "state": "Karnataka",
    "addressLine1": "Bilal Masjid, Mailuru Road, Kalidas Nagar, Mailura, Bidar, Bidar taluku, Bidar, Karnataka, 585400, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 17.8939031,
    "longitude": 77.507762,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Bilal Masjid is an OpenStreetMap-listed mosque/place of worship in Mailura, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196831784",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 151
  },
  {
    "id": "osm-node-8196831756",
    "slug": "masjid-e-omar-farooq-old-city-bidar",
    "nameEnglish": "Masjid E Omar Farooq",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Old City",
    "state": "Karnataka",
    "addressLine1": "Masjid E Omar Farooq, ಮುಖ್ಯ ರಸ್ತೆ, Gauli Gully, Old City, Bidar, Bidar taluku, Bidar, Karnataka, 585400, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 17.9174841,
    "longitude": 77.523356,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid E Omar Farooq is an OpenStreetMap-listed mosque/place of worship in Old City, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196831756",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 152
  },
  {
    "id": "osm-node-13167485132",
    "slug": "osmaniyah-masjid-old-city-bidar",
    "nameEnglish": "Osmaniyah Masjid",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Old City",
    "state": "Karnataka",
    "addressLine1": "Osmaniyah Masjid, ಮುಖ್ಯ ರಸ್ತೆ, Gauli Gully, Old City, Bidar, Bidar taluku, Bidar, Karnataka, 585400, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 17.9153873,
    "longitude": 77.5246273,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Osmaniyah Masjid is an OpenStreetMap-listed mosque/place of worship in Old City, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13167485132",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 153
  },
  {
    "id": "osm-node-8196831776",
    "slug": "masjid-e-fatah-bidar-halladhakeri-bidar",
    "nameEnglish": "Masjid E Fatah Bidar",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Halladhakeri",
    "state": "Karnataka",
    "addressLine1": "Masjid E Fatah Bidar, Kumbarwada road, Rajabagh, Halladhakeri, Bidar, Bidar taluku, Bidar, Karnataka, 585400, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 17.9050459,
    "longitude": 77.5288103,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid E Fatah Bidar is an OpenStreetMap-listed mosque/place of worship in Halladhakeri, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196831776",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 154
  },
  {
    "id": "osm-node-8196831805",
    "slug": "jamia-masjid-amlapur-nagora-bidar",
    "nameEnglish": "Jamia Masjid Amlapur",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Nagora",
    "state": "Karnataka",
    "addressLine1": "Jamia Masjid Amlapur, SH122, Nagora, Nagura, Bidar taluku, Bidar, Karnataka, 585226, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 17.8751814,
    "longitude": 77.5032105,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamia Masjid Amlapur is an OpenStreetMap-listed mosque/place of worship in Nagora, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196831805",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 155
  },
  {
    "id": "osm-node-13146401058",
    "slug": "masjid-e-eilahi-old-city-bidar",
    "nameEnglish": "Masjid - e - Eilahi",
    "nameUrdu": null,
    "city": "Bidar",
    "district": "Old City",
    "state": "Karnataka",
    "addressLine1": "Masjid - e - Eilahi, Udgir Road, Multani Colony, Old City, Bidar, Bidar taluku, Bidar, Karnataka, 585400, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:42",
    "latitude": 17.9145635,
    "longitude": 77.518766,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid - e - Eilahi is an OpenStreetMap-listed mosque/place of worship in Old City, Bidar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13146401058",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 156
  },
  {
    "id": "osm-node-10594007888",
    "slug": "indianoor-mahallu-juma-masjid-indianoor-malappuram",
    "nameEnglish": "Indianoor Mahallu Juma Masjid ഇന്ത്യനൂർ മഹല്ല് ജുമാ മസ്ജിദ്",
    "nameUrdu": null,
    "city": "Malappuram",
    "district": "Indianoor",
    "state": "Kerala",
    "addressLine1": "Indianoor Mahallu Juma Masjid ഇന്ത്യനൂർ മഹല്ല് ജുമാ മസ്ജിദ്, Kundodi road, Indianoor, Kottakkal, Ernad, Malappuram, Kerala, 676503, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:51",
    "latitude": 10.9807387,
    "longitude": 76.0391146,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Indianoor Mahallu Juma Masjid ഇന്ത്യനൂർ മഹല്ല് ജുമാ മസ്ജിദ് is an OpenStreetMap-listed mosque/place of worship in Indianoor, Malappuram. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/10594007888",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 157
  },
  {
    "id": "osm-way-805998309",
    "slug": "kakkad-mahal-juma-masjid-koalapalla-colony-kannur",
    "nameEnglish": "Kakkad Mahal Juma Masjid",
    "nameUrdu": null,
    "city": "Kannur",
    "district": "Koalapalla Colony",
    "state": "Kerala",
    "addressLine1": "Kakkad Mahal Juma Masjid, Puzhathi school road, Koalapalla Colony, Elayavoor, Kannur, Kerala, 670005, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 11.8924124,
    "longitude": 75.387717,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kakkad Mahal Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Koalapalla Colony, Kannur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/805998309",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 158
  },
  {
    "id": "osm-way-805998301",
    "slug": "kakkad-hydrose-juma-masjid-koalapalla-colony-kannur",
    "nameEnglish": "Kakkad Hydrose Juma Masjid",
    "nameUrdu": null,
    "city": "Kannur",
    "district": "Koalapalla Colony",
    "state": "Kerala",
    "addressLine1": "Kakkad Hydrose Juma Masjid, Thana Kakkad Road, Koalapalla Colony, Elayavoor, Kannur, Kerala, 670005, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 11.8911285,
    "longitude": 75.3869759,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kakkad Hydrose Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Koalapalla Colony, Kannur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/805998301",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 159
  },
  {
    "id": "osm-node-12774526699",
    "slug": "kunhipalli-juma-masjid-puzhathi-kannur",
    "nameEnglish": "Kunhipalli Juma Masjid",
    "nameUrdu": null,
    "city": "Kannur",
    "district": "Puzhathi",
    "state": "Kerala",
    "addressLine1": "Kunhipalli Juma Masjid, Thana Kakkad Road, Puzhathi, Kannur, Kerala, 670005, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 11.8985932,
    "longitude": 75.3850038,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kunhipalli Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Puzhathi, Kannur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12774526699",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 160
  },
  {
    "id": "osm-node-12800205301",
    "slug": "hidros-juma-masjid-koalapalla-colony-kannur",
    "nameEnglish": "Hidros Juma Masjid",
    "nameUrdu": null,
    "city": "Kannur",
    "district": "Koalapalla Colony",
    "state": "Kerala",
    "addressLine1": "Hidros Juma Masjid, Thana Kakkad Road, Koalapalla Colony, Elayavoor, Kannur, Kerala, 670005, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 11.8911293,
    "longitude": 75.3869809,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Hidros Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Koalapalla Colony, Kannur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/12800205301",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 161
  },
  {
    "id": "osm-node-1681428891",
    "slug": "sharara-juma-masjid-kuyyali-kannur",
    "nameEnglish": "Sharara Juma Masjid",
    "nameUrdu": null,
    "city": "Kannur",
    "district": "Kuyyali",
    "state": "Kerala",
    "addressLine1": "Sharara Juma Masjid, Kuyali Road, Kuyyali, Thalassery, Kannur, Kerala, 670100, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 11.7573911,
    "longitude": 75.4894899,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Sharara Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Kuyyali, Kannur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/1681428891",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 162
  },
  {
    "id": "osm-node-5876072668",
    "slug": "vayad-juma-masjid-ammanappara-pacheni-vayad-chapparappadavu-road-kannur",
    "nameEnglish": "Vayad Juma Masjid",
    "nameUrdu": null,
    "city": "Kannur",
    "district": "Ammanappara - Pacheni - Vayad- Chapparappadavu Road",
    "state": "Kerala",
    "addressLine1": "Vayad Juma Masjid, Ammanappara - Pacheni - Vayad- Chapparappadavu Road, Alathattu Colony, Vayad, Taliparamba, Kannur, Kerala, 670502, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:54",
    "latitude": 12.0929148,
    "longitude": 75.3498301,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Vayad Juma Masjid is an OpenStreetMap-listed mosque/place of worship in Ammanappara - Pacheni - Vayad- Chapparappadavu Road, Kannur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/5876072668",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 163
  },
  {
    "id": "osm-way-690889562",
    "slug": "al-rifa-sunni-jamia-masjid-manoorkonam-thiruvananthapuram",
    "nameEnglish": "Al Rifa Sunni Jamia Masjid",
    "nameUrdu": null,
    "city": "Thiruvananthapuram",
    "district": "Manoorkonam",
    "state": "Kerala",
    "addressLine1": "Al Rifa Sunni Jamia Masjid, Thiruvananthapuram - Ponmudi Road, Manoorkonam, Tholicode, Nedumangad, Thiruvananthapuram, Kerala, 695541, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 8.6446895,
    "longitude": 77.0549356,
    "facilities": [
      "Prayer Hall",
      "Women section"
    ],
    "description": "Al Rifa Sunni Jamia Masjid is an OpenStreetMap-listed mosque/place of worship in Manoorkonam, Thiruvananthapuram. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/690889562",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 164
  },
  {
    "id": "osm-way-66292232",
    "slug": "tipu-masjid-vadakovai-coimbatore",
    "nameEnglish": "Tipu Masjid",
    "nameUrdu": null,
    "city": "Coimbatore",
    "district": "Vadakovai",
    "state": "Tamil Nadu",
    "addressLine1": "Tipu Masjid, Mettupalayam Road, Vadakovai, Ward 23, West Zone, Coimbatore South, Coimbatore, Tamil Nadu, 641007, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 11.0078555,
    "longitude": 76.9544124,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Tipu Masjid is an OpenStreetMap-listed mosque/place of worship in Vadakovai, Coimbatore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/66292232",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 165
  },
  {
    "id": "osm-way-697141357",
    "slug": "masjid-e-noor-dhakkni-sunnath-jamath-kovilpalayam-coimbatore",
    "nameEnglish": "Masjid e Noor Dhakkni Sunnath Jamath",
    "nameUrdu": null,
    "city": "Coimbatore",
    "district": "Kovilpalayam",
    "state": "Tamil Nadu",
    "addressLine1": "Masjid e Noor Dhakkni Sunnath Jamath, Coimbatore - Sathyamangalam Road, Kovilpalayam, Kariampalayam, Coimbatore North, Coimbatore, Tamil Nadu, 641107, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 11.1328434,
    "longitude": 77.0326049,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid e Noor Dhakkni Sunnath Jamath is an OpenStreetMap-listed mosque/place of worship in Kovilpalayam, Coimbatore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/697141357",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 166
  },
  {
    "id": "osm-way-746356220",
    "slug": "masjid-jannathul-firdouse-sivanandhapuram-coimbatore",
    "nameEnglish": "Masjid Jannathul Firdouse",
    "nameUrdu": null,
    "city": "Coimbatore",
    "district": "Sivanandhapuram",
    "state": "Tamil Nadu",
    "addressLine1": "Masjid Jannathul Firdouse, Sathyamangalam Road, Sivanandhapuram, Ward 29, North Zone, Coimbatore, Coimbatore North, Coimbatore, Tamil Nadu, 641001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 11.0658955,
    "longitude": 76.9978406,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid Jannathul Firdouse is an OpenStreetMap-listed mosque/place of worship in Sivanandhapuram, Coimbatore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/746356220",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 167
  },
  {
    "id": "osm-node-9567217471",
    "slug": "athar-jamaath-masjid-town-hall-coimbatore",
    "nameEnglish": "Athar Jamaath Masjid",
    "nameUrdu": null,
    "city": "Coimbatore",
    "district": "Town Hall",
    "state": "Tamil Nadu",
    "addressLine1": "Athar Jamaath Masjid, Oppanakara Street, Town Hall, Ward 83, Central Zone, Podanur, Coimbatore South, Coimbatore, Tamil Nadu, 641007, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 10.9935623,
    "longitude": 76.9594291,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Athar Jamaath Masjid is an OpenStreetMap-listed mosque/place of worship in Town Hall, Coimbatore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/9567217471",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 168
  },
  {
    "id": "osm-way-1082462595",
    "slug": "madeena-masjid-jothi-nagar-coimbatore",
    "nameEnglish": "Madeena Masjid",
    "nameUrdu": null,
    "city": "Coimbatore",
    "district": "Jothi Nagar",
    "state": "Tamil Nadu",
    "addressLine1": "Madeena Masjid, Kalaimagal Ramasamy Road, Jothi Nagar, Pollachi, Coimbatore, Tamil Nadu, 642001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 10.649184,
    "longitude": 77.0108135,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Madeena Masjid is an OpenStreetMap-listed mosque/place of worship in Jothi Nagar, Coimbatore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1082462595",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 169
  },
  {
    "id": "osm-node-1470819716",
    "slug": "kattor-masjid-mettupalayam-to-bathirakaliamman-koil-coimbatore",
    "nameEnglish": "Kattor Masjid",
    "nameUrdu": null,
    "city": "Coimbatore",
    "district": "Mettupalayam to Bathirakaliamman Koil",
    "state": "Tamil Nadu",
    "addressLine1": "Kattor Masjid, Mettupalayam to Bathirakaliamman Koil, Mettupalayam, Coimbatore, Tamil Nadu, 641301, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:48",
    "latitude": 11.3008195,
    "longitude": 76.9317812,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kattor Masjid is an OpenStreetMap-listed mosque/place of worship in Mettupalayam to Bathirakaliamman Koil, Coimbatore. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/1470819716",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 170
  },
  {
    "id": "osm-way-949998929",
    "slug": "kazimar-big-mosque-jaihindpuram-madurai",
    "nameEnglish": "Kazimar Big Mosque",
    "nameUrdu": null,
    "city": "Madurai",
    "district": "Jaihindpuram",
    "state": "Tamil Nadu",
    "addressLine1": "Kazimar Big Mosque, Kazimar Street, Main Road, Jaihindpuram, Madurai, Madurai South, Madurai, Tamil Nadu, 625011, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "https://www.google.com/maps/uv?pb=!1s0x3b00c581d7d0773b%3A0x9bf62d7981443494!3m1!7e115!4shttps%3A%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipOEJE4Y_IJfZukbZDk3fAlXe8N6ECVZqMbv7Ohi%3Dw426-h240-k-no!5skazimar%20big%20mosque%20address%20-%20Google%20Search!1",
    "coverPhoto": "https://www.google.com/maps/uv?pb=!1s0x3b00c581d7d0773b%3A0x9bf62d7981443494!3m1!7e115!4shttps%3A%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipOEJE4Y_IJfZukbZDk3fAlXe8N6ECVZqMbv7Ohi%3Dw426-h240-k-no!5skazimar%20big%20mosque%20address%20-%20Google%20Search!1",
    "photos": [
      "https://www.google.com/maps/uv?pb=!1s0x3b00c581d7d0773b%3A0x9bf62d7981443494!3m1!7e115!4shttps%3A%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipOEJE4Y_IJfZukbZDk3fAlXe8N6ECVZqMbv7Ohi%3Dw426-h240-k-no!5skazimar%20big%20mosque%20address%20-%20Google%20Search!1"
    ],
    "nextSalah": "Asr · 15:43",
    "latitude": 9.9127352,
    "longitude": 78.1142518,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Kazimar Big Mosque is an OpenStreetMap-listed mosque/place of worship in Jaihindpuram, Madurai. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/949998929",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 171
  },
  {
    "id": "osm-way-1169392092",
    "slug": "masjid-al-bilal-ss-colony-mosque-ss-colony-madurai",
    "nameEnglish": "Masjid AL Bilal SS Colony Mosque",
    "nameUrdu": null,
    "city": "Madurai",
    "district": "SS Colony",
    "state": "Tamil Nadu",
    "addressLine1": "Masjid AL Bilal SS Colony Mosque, Valluvar Street, S S Colony, SS Colony, Madurai, Madurai South, Madurai, Tamil Nadu, 625010, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:43",
    "latitude": 9.9203325,
    "longitude": 78.0969481,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid AL Bilal SS Colony Mosque is an OpenStreetMap-listed mosque/place of worship in SS Colony, Madurai. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1169392092",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 172
  },
  {
    "id": "osm-way-1166123989",
    "slug": "east-madurai-mosque-balarengapuram-madurai",
    "nameEnglish": "East Madurai Mosque",
    "nameUrdu": null,
    "city": "Madurai",
    "district": "Balarengapuram",
    "state": "Tamil Nadu",
    "addressLine1": "East Madurai Mosque, Old East Madurai Station Road, Anuppanadi, Balarengapuram, Madurai, Madurai South, Madurai, Tamil Nadu, 625009, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:43",
    "latitude": 9.9103437,
    "longitude": 78.1339401,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "East Madurai Mosque is an OpenStreetMap-listed mosque/place of worship in Balarengapuram, Madurai. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/1166123989",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 173
  },
  {
    "id": "osm-way-489211711",
    "slug": "quadam-rasul-masjid-barabati-fort-cuttack",
    "nameEnglish": "Quadam Rasul Masjid",
    "nameUrdu": null,
    "city": "Cuttack",
    "district": "Barabati Fort",
    "state": "Odisha",
    "addressLine1": "Quadam Rasul Masjid, Kala Vikash Kendra Road, Barabati Fort, Cuttack, Cuttack (M.Corp.) P.S, Cuttack, Odisha, 753001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:06",
    "latitude": 20.466995,
    "longitude": 85.870633,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Quadam Rasul Masjid is an OpenStreetMap-listed mosque/place of worship in Barabati Fort, Cuttack. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/489211711",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 174
  },
  {
    "id": "osm-way-469232657",
    "slug": "iqra-masjid-pardih-jamshedpur",
    "nameEnglish": "Iqra Masjid",
    "nameUrdu": null,
    "city": "Jamshedpur",
    "district": "Pārdih",
    "state": "Jharkhand",
    "addressLine1": "Iqra Masjid, Iqra Colony and Sundarban, Pārdih, Jamshedpur, Golmuri-Cum-Jugsalai, East Singhbhum, Jharkhand, 831001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:01",
    "latitude": 22.842403,
    "longitude": 86.2034526,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Iqra Masjid is an OpenStreetMap-listed mosque/place of worship in Pārdih, Jamshedpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/469232657",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 175
  },
  {
    "id": "osm-node-1273773617",
    "slug": "rani-kudar-masjid-outer-circle-road-jamshedpur",
    "nameEnglish": "Rani Kudar Masjid",
    "nameUrdu": null,
    "city": "Jamshedpur",
    "district": "Outer Circle Road",
    "state": "Jharkhand",
    "addressLine1": "Rani Kudar Masjid, Outer Circle Road, Jamshedpur, Golmuri-Cum-Jugsalai, East Singhbhum, Jharkhand, 831001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:01",
    "latitude": 22.796558,
    "longitude": 86.1732493,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Rani Kudar Masjid is an OpenStreetMap-listed mosque/place of worship in Outer Circle Road, Jamshedpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/1273773617",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 176
  },
  {
    "id": "osm-node-1273821675",
    "slug": "dhatkidih-masjid-bc-road-jamshedpur",
    "nameEnglish": "Dhatkidih Masjid",
    "nameUrdu": null,
    "city": "Jamshedpur",
    "district": "BC-Road",
    "state": "Jharkhand",
    "addressLine1": "Dhatkidih Masjid, BC-Road, Jamshedpur, Golmuri-Cum-Jugsalai, East Singhbhum, Jharkhand, 831001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:01",
    "latitude": 22.8027198,
    "longitude": 86.1807166,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Dhatkidih Masjid is an OpenStreetMap-listed mosque/place of worship in BC-Road, Jamshedpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/1273821675",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 177
  },
  {
    "id": "osm-node-11691530659",
    "slug": "munshi-mohalla-masjid-sunni-hanafi-post-office-road-jamshedpur",
    "nameEnglish": "Munshi Mohalla Masjid - Sunni Hanafi",
    "nameUrdu": null,
    "city": "Jamshedpur",
    "district": "Post Office Road",
    "state": "Jharkhand",
    "addressLine1": "Munshi Mohalla Masjid - Sunni Hanafi, Post Office Road, Jamshedpur, Golmuri-Cum-Jugsalai, East Singhbhum, Jharkhand, 831001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:01",
    "latitude": 22.8209233,
    "longitude": 86.2146919,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Munshi Mohalla Masjid - Sunni Hanafi is an OpenStreetMap-listed mosque/place of worship in Post Office Road, Jamshedpur. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/11691530659",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 178
  },
  {
    "id": "osm-node-13784102673",
    "slug": "meherpur-puraton-jama-masjid-zilani-choudhury-lane-silchar",
    "nameEnglish": "Meherpur Puraton Jama Masjid",
    "nameUrdu": null,
    "city": "Silchar",
    "district": "Zilani Choudhury Lane",
    "state": "Assam",
    "addressLine1": "Meherpur Puraton Jama Masjid, Zilani Choudhury Lane, Silchar, Cachar, Assam, 788014, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 14:40",
    "latitude": 24.8006239,
    "longitude": 92.7920328,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Meherpur Puraton Jama Masjid is an OpenStreetMap-listed mosque/place of worship in Zilani Choudhury Lane, Silchar. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13784102673",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 179
  },
  {
    "id": "osm-node-7159077259",
    "slug": "hazrat-makhdum-shah-masjid-bhavna-colony-ahmedabad",
    "nameEnglish": "Hazrat Makhdum Shah Masjid",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "Bhavna colony",
    "state": "Gujarat",
    "addressLine1": "Hazrat Makhdum Shah Masjid, Jamalpur Road, Bhavna colony, Maninagar Taluka, Ahmedabad, Gujarat, 380001, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 23.013937,
    "longitude": 72.584312,
    "facilities": [
      "Prayer Hall",
      "Wheelchair access"
    ],
    "description": "Hazrat Makhdum Shah Masjid is an OpenStreetMap-listed mosque/place of worship in Bhavna colony, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7159077259",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 180
  },
  {
    "id": "osm-way-783534572",
    "slug": "khan-masjid-sh74-ahmedabad",
    "nameEnglish": "Khan Masjid",
    "nameUrdu": null,
    "city": "Ahmedabad",
    "district": "SH74",
    "state": "Gujarat",
    "addressLine1": "Khan Masjid, SH74, Bavla, Dholka Taluka, Ahmedabad, Gujarat, 382220, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 22.7338192,
    "longitude": 72.4313439,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Khan Masjid is an OpenStreetMap-listed mosque/place of worship in SH74, Ahmedabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/783534572",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 181
  },
  {
    "id": "osm-node-7516911443",
    "slug": "salafi-juma-masjid-mavoor-areacode-road-kozhikode",
    "nameEnglish": "Salafi Juma Masjid സലഫി ജുമാ മസ്ജിദ്",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Mavoor-Areacode Road",
    "state": "Kerala",
    "addressLine1": "Salafi Juma Masjid സലഫി ജുമാ മസ്ജിദ്, Mavoor-Areacode Road, Chullikkaparamb, Koolimadu, Kozhikode, Kerala, 613639, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.2702177,
    "longitude": 76.0164506,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Salafi Juma Masjid സലഫി ജുമാ മസ്ജിദ് is an OpenStreetMap-listed mosque/place of worship in Mavoor-Areacode Road, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7516911443",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 182
  },
  {
    "id": "osm-way-894286458",
    "slug": "muliyangal-sunni-jumma-masjid-puthiyangadi-koothuparamba-road-kozhikode",
    "nameEnglish": "muliyangal sunni jumma masjid",
    "nameUrdu": null,
    "city": "Kozhikode",
    "district": "Puthiyangadi - Koothuparamba Road",
    "state": "Kerala",
    "addressLine1": "muliyangal sunni jumma masjid, Puthiyangadi - Koothuparamba Road, Thayyil Thazhe, Muliyangal, Koyilandi, Kozhikode, Kerala, 673624, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:52",
    "latitude": 11.5343423,
    "longitude": 75.77322,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "muliyangal sunni jumma masjid is an OpenStreetMap-listed mosque/place of worship in Puthiyangadi - Koothuparamba Road, Kozhikode. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:way/894286458",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 183
  },
  {
    "id": "osm-node-7798326774",
    "slug": "asthal-jamia-masjid-krishnapura-mangaluru",
    "nameEnglish": "Asthal Jamia masjid",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Krishnapura",
    "state": "Karnataka",
    "addressLine1": "Asthal Jamia masjid, Krishnapura Road, Krishnapura, Mangaluru, Mangaluru taluk, Dakshina Kannada, Karnataka, 575014, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 12.9982455,
    "longitude": 74.8151443,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Asthal Jamia masjid is an OpenStreetMap-listed mosque/place of worship in Krishnapura, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/7798326774",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 184
  },
  {
    "id": "osm-node-8196836436",
    "slug": "khilla-sunni-jamia-masjid-kotebagilu-solapur-mangalore-highway-mangaluru",
    "nameEnglish": "Khilla Sunni Jamia Masjid Kotebagilu",
    "nameUrdu": null,
    "city": "Mangaluru",
    "district": "Solapur-Mangalore Highway",
    "state": "Karnataka",
    "addressLine1": "Khilla Sunni Jamia Masjid Kotebagilu, Solapur-Mangalore Highway, Moodabidri, Moodabidri taluk, Dakshina Kannada, Karnataka, 574227, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:56",
    "latitude": 13.0751975,
    "longitude": 75.0085826,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Khilla Sunni Jamia Masjid Kotebagilu is an OpenStreetMap-listed mosque/place of worship in Solapur-Mangalore Highway, Mangaluru. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196836436",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 185
  },
  {
    "id": "osm-node-13845369469",
    "slug": "masjid-pachhayyan-mdr150w-moradabad",
    "nameEnglish": "Masjid Pachhayyan",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "MDR150W",
    "state": "Uttar Pradesh",
    "addressLine1": "Masjid Pachhayyan, MDR150W, Umri Kalan, Moradabad, Amroha, Uttar Pradesh, 244501, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 29.039434,
    "longitude": 78.5662155,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Masjid Pachhayyan is an OpenStreetMap-listed mosque/place of worship in MDR150W, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13845369469",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 186
  },
  {
    "id": "osm-node-13845369470",
    "slug": "mullano-wali-masjid-mdr150w-moradabad",
    "nameEnglish": "Mullano Wali Masjid",
    "nameUrdu": null,
    "city": "Moradabad",
    "district": "MDR150W",
    "state": "Uttar Pradesh",
    "addressLine1": "Mullano Wali Masjid, MDR150W, Umri Kalan, Moradabad, Amroha, Uttar Pradesh, 244501, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:47",
    "latitude": 29.039711,
    "longitude": 78.5670932,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Mullano Wali Masjid is an OpenStreetMap-listed mosque/place of worship in MDR150W, Moradabad. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/13845369470",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 187
  },
  {
    "id": "osm-node-8196832079",
    "slug": "jamiya-masjid-gazipura-jamiyat-e-ahelehadees-rauza-kalaburagi",
    "nameEnglish": "Jamiya Masjid Gazipura Jamiyat -e- Ahelehadees",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "Rauza",
    "state": "Karnataka",
    "addressLine1": "Jamiya Masjid Gazipura Jamiyat -e- Ahelehadees, Nehru Ganj, Rauza, Kalaburagi, Kalaburagi taluku, Kalaburagi, Karnataka, 585101, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.3396601,
    "longitude": 76.8396872,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Jamiya Masjid Gazipura Jamiyat -e- Ahelehadees is an OpenStreetMap-listed mosque/place of worship in Rauza, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196832079",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 188
  },
  {
    "id": "osm-node-8196831992",
    "slug": "mecca-masjid-nh167n-kalaburagi",
    "nameEnglish": "Mecca Masjid",
    "nameUrdu": null,
    "city": "Kalaburagi",
    "district": "NH167N",
    "state": "Karnataka",
    "addressLine1": "Mecca Masjid, NH167N, Chincholi, Chincholi taluku, Kalaburagi, Karnataka, 585307, India",
    "sect": null,
    "capacity": null,
    "verified": false,
    "rating": null,
    "reviews": null,
    "plan": "free",
    "planLabel": "Listed",
    "imam": "",
    "president": "",
    "phone": "",
    "contactPhone": "",
    "contactEmail": "",
    "isWaqf": false,
    "isWaqfRegistered": false,
    "photo": "",
    "coverPhoto": "",
    "photos": [],
    "nextSalah": "Asr · 15:45",
    "latitude": 17.470315,
    "longitude": 77.4293886,
    "facilities": [
      "Prayer Hall"
    ],
    "description": "Mecca Masjid is an OpenStreetMap-listed mosque/place of worship in NH167N, Kalaburagi. Coordinates and public address fields are sourced from OSM; committee details require verification.",
    "importSource": "OpenStreetMap:Nominatim:node/8196831992",
    "sourceQuality": "osm-nominatim-display-name",
    "pilotSort": 189
  }
]
